webpackJsonp([1],{

/***/ 2:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HTTP; });
/* harmony export (immutable) */ __webpack_exports__["b"] = getCountryFlagUrl;
/* harmony export (immutable) */ __webpack_exports__["c"] = getCountryName;
/* harmony export (immutable) */ __webpack_exports__["g"] = getTagName;
/* harmony export (immutable) */ __webpack_exports__["e"] = getTagIconText;
/* harmony export (immutable) */ __webpack_exports__["f"] = getTagIconUrl;
/* harmony export (immutable) */ __webpack_exports__["d"] = getHrefUrl;
/* harmony export (immutable) */ __webpack_exports__["h"] = showError;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lookups__ = __webpack_require__(21);



var HTTP = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
  baseURL: 'https://mevris-bridge.better-hotel.com/api/black-list/',

  responseType: 'json',
  timeout: 10000
});

function getCountryFlagUrl(iso) {
  if (!__WEBPACK_IMPORTED_MODULE_1__lookups__["a" /* COUNTRIES */].has(iso)) {
    return '';
  }
  var country = __WEBPACK_IMPORTED_MODULE_1__lookups__["a" /* COUNTRIES */].get(iso);
  return 'static/img/flags/' + country.alpha2 + '.png';
}

function getCountryName(vue, iso) {
  if (!__WEBPACK_IMPORTED_MODULE_1__lookups__["a" /* COUNTRIES */].has(iso)) {
    return '';
  }
  var country = __WEBPACK_IMPORTED_MODULE_1__lookups__["a" /* COUNTRIES */].get(iso);
  return vue.$t('country_' + country.alpha2);
}

function getTagName(vue, code) {
  if (!__WEBPACK_IMPORTED_MODULE_1__lookups__["b" /* TAGS */].has(code)) {
    return '';
  }
  return vue.$t('tag_' + code);
}

function getTagIconText(code) {
  if (!__WEBPACK_IMPORTED_MODULE_1__lookups__["b" /* TAGS */].has(code)) {
    return '';
  }
  return __WEBPACK_IMPORTED_MODULE_1__lookups__["b" /* TAGS */].get(code).icon_text;
}

function getTagIconUrl(code) {
  if (!__WEBPACK_IMPORTED_MODULE_1__lookups__["b" /* TAGS */].has(code)) {
    return '';
  }
  return 'static/img/tag_reason/' + code + '.png';
}

function getHrefUrl(url) {
  if (!url) {
    return '';
  }
  return url.startsWith('http', true) ? url : 'http://' + url;
}

function showError(vue, message) {
  vue.$swal({
    position: 'bottom-right',
    type: 'error',
    title: vue.$t('error'),
    text: message,
    showConfirmButton: false,
    timer: 3000
  });
}

/***/ }),

/***/ 21:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TAGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return COUNTRIES; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__);

var TAGS = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default.a([['nopay', { icon_text: '1', icon_url: '' }], ['thief', { icon_text: '2', icon_url: '' }], ['noshow', { icon_text: '3', icon_url: '' }], ['aggresor', { icon_text: '4', icon_url: '' }], ['debtor', { icon_text: '5', icon_url: '' }], ['drugs', { icon_text: '6', icon_url: '' }], ['fraud', { icon_text: '7', icon_url: '' }], ['identity', { icon_text: '8', icon_url: '' }], ['duplicity', { icon_text: '9', icon_url: '' }], ['other', { icon_text: '?', icon_url: '' }]]);

var COUNTRIES = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default.a([['AFG', { numeric: '004', alpha2: 'AF' }], ['ALA', { numeric: '248', alpha2: 'AX' }], ['ALB', { numeric: '008', alpha2: 'AL' }], ['DZA', { numeric: '012', alpha2: 'DZ' }], ['ASM', { numeric: '016', alpha2: 'AS' }], ['VIR', { numeric: '850', alpha2: 'VI' }], ['AND', { numeric: '020', alpha2: 'AD' }], ['AGO', { numeric: '024', alpha2: 'AO' }], ['AIA', { numeric: '660', alpha2: 'AI' }], ['ATA', { numeric: '010', alpha2: 'AQ' }], ['ATG', { numeric: '028', alpha2: 'AG' }], ['ARG', { numeric: '032', alpha2: 'AR' }], ['ARM', { numeric: '051', alpha2: 'AM' }], ['ABW', { numeric: '533', alpha2: 'AW' }], ['AUS', { numeric: '036', alpha2: 'AU' }], ['AZE', { numeric: '031', alpha2: 'AZ' }], ['BHS', { numeric: '044', alpha2: 'BS' }], ['BHR', { numeric: '048', alpha2: 'BH' }], ['BGD', { numeric: '050', alpha2: 'BD' }], ['BRB', { numeric: '052', alpha2: 'BB' }], ['BEL', { numeric: '056', alpha2: 'BE' }], ['BLZ', { numeric: '084', alpha2: 'BZ' }], ['BLR', { numeric: '112', alpha2: 'BY' }], ['BEN', { numeric: '204', alpha2: 'BJ' }], ['BMU', { numeric: '060', alpha2: 'BM' }], ['BTN', { numeric: '064', alpha2: 'BT' }], ['BOL', { numeric: '068', alpha2: 'BO' }], ['BIH', { numeric: '070', alpha2: 'BA' }], ['BWA', { numeric: '072', alpha2: 'BW' }], ['BVT', { numeric: '074', alpha2: 'BV' }], ['BRA', { numeric: '076', alpha2: 'BR' }], ['IOT', { numeric: '086', alpha2: 'IO' }], ['VGB', { numeric: '092', alpha2: 'VG' }], ['BRN', { numeric: '096', alpha2: 'BN' }], ['BGR', { numeric: '100', alpha2: 'BG' }], ['BFA', { numeric: '854', alpha2: 'BF' }], ['BDI', { numeric: '108', alpha2: 'BI' }], ['COK', { numeric: '184', alpha2: 'CK' }], ['TCD', { numeric: '148', alpha2: 'TD' }], ['MNE', { numeric: '499', alpha2: 'ME' }], ['CZE', { numeric: '203', alpha2: 'CZ' }], ['CHN', { numeric: '156', alpha2: 'CN' }], ['DNK', { numeric: '208', alpha2: 'DK' }], ['COD', { numeric: '180', alpha2: 'CD' }], ['DMA', { numeric: '212', alpha2: 'DM' }], ['DOM', { numeric: '214', alpha2: 'DO' }], ['DJI', { numeric: '262', alpha2: 'DJ' }], ['EGY', { numeric: '818', alpha2: 'EG' }], ['ECU', { numeric: '218', alpha2: 'EC' }], ['ERI', { numeric: '232', alpha2: 'ER' }], ['EST', { numeric: '233', alpha2: 'EE' }], ['ETH', { numeric: '231', alpha2: 'ET' }], ['FRO', { numeric: '234', alpha2: 'FO' }], ['FLK', { numeric: '238', alpha2: 'FK' }], ['FJI', { numeric: '242', alpha2: 'FJ' }], ['PHL', { numeric: '608', alpha2: 'PH' }], ['FIN', { numeric: '246', alpha2: 'FI' }], ['FRA', { numeric: '250', alpha2: 'FR' }], ['GUF', { numeric: '254', alpha2: 'GF' }], ['ATF', { numeric: '260', alpha2: 'TF' }], ['PYF', { numeric: '258', alpha2: 'PF' }], ['GAB', { numeric: '266', alpha2: 'GA' }], ['GMB', { numeric: '270', alpha2: 'GM' }], ['GHA', { numeric: '288', alpha2: 'GH' }], ['GIB', { numeric: '292', alpha2: 'GI' }], ['GRD', { numeric: '308', alpha2: 'GD' }], ['GRL', { numeric: '304', alpha2: 'GL' }], ['GEO', { numeric: '268', alpha2: 'GE' }], ['GLP', { numeric: '312', alpha2: 'GP' }], ['GUM', { numeric: '316', alpha2: 'GU' }], ['GTM', { numeric: '320', alpha2: 'GT' }], ['GIN', { numeric: '324', alpha2: 'GN' }], ['GNB', { numeric: '624', alpha2: 'GW' }], ['GGY', { numeric: '831', alpha2: 'GG' }], ['GUY', { numeric: '328', alpha2: 'GY' }], ['HTI', { numeric: '332', alpha2: 'HT' }], ['HMD', { numeric: '334', alpha2: 'HM' }], ['HND', { numeric: '340', alpha2: 'HN' }], ['HKG', { numeric: '344', alpha2: 'HK' }], ['CHL', { numeric: '152', alpha2: 'CL' }], ['HRV', { numeric: '191', alpha2: 'HR' }], ['IND', { numeric: '356', alpha2: 'IN' }], ['IDN', { numeric: '360', alpha2: 'ID' }], ['IRQ', { numeric: '368', alpha2: 'IQ' }], ['IRN', { numeric: '364', alpha2: 'IR' }], ['IRL', { numeric: '372', alpha2: 'IE' }], ['ISL', { numeric: '352', alpha2: 'IS' }], ['ITA', { numeric: '380', alpha2: 'IT' }], ['ISR', { numeric: '376', alpha2: 'IL' }], ['JAM', { numeric: '388', alpha2: 'JM' }], ['JPN', { numeric: '392', alpha2: 'JP' }], ['YEM', { numeric: '887', alpha2: 'YE' }], ['JEY', { numeric: '832', alpha2: 'JE' }], ['ZAF', { numeric: '710', alpha2: 'ZA' }], ['SGS', { numeric: '239', alpha2: 'GS' }], ['KOR', { numeric: '410', alpha2: 'KR' }], ['JOR', { numeric: '400', alpha2: 'JO' }], ['CYM', { numeric: '136', alpha2: 'KY' }], ['KHM', { numeric: '116', alpha2: 'KH' }], ['CMR', { numeric: '120', alpha2: 'CM' }], ['CAN', { numeric: '124', alpha2: 'CA' }], ['CPV', { numeric: '132', alpha2: 'CV' }], ['QAT', { numeric: '634', alpha2: 'QA' }], ['KAZ', { numeric: '398', alpha2: 'KZ' }], ['KEN', { numeric: '404', alpha2: 'KE' }], ['KIR', { numeric: '296', alpha2: 'KI' }], ['CCK', { numeric: '166', alpha2: 'CC' }], ['COL', { numeric: '170', alpha2: 'CO' }], ['COM', { numeric: '174', alpha2: 'KM' }], ['COG', { numeric: '178', alpha2: 'CG' }], ['CRI', { numeric: '188', alpha2: 'CR' }], ['CUB', { numeric: '192', alpha2: 'CU' }], ['KWT', { numeric: '414', alpha2: 'KW' }], ['CYP', { numeric: '196', alpha2: 'CY' }], ['KGZ', { numeric: '417', alpha2: 'KG' }], ['LAO', { numeric: '418', alpha2: 'LA' }], ['LSO', { numeric: '426', alpha2: 'LS' }], ['LBN', { numeric: '422', alpha2: 'LB' }], ['LBR', { numeric: '430', alpha2: 'LR' }], ['LBY', { numeric: '434', alpha2: 'LY' }], ['LIE', { numeric: '438', alpha2: 'LI' }], ['LTU', { numeric: '440', alpha2: 'LT' }], ['LVA', { numeric: '428', alpha2: 'LV' }], ['LUX', { numeric: '442', alpha2: 'LU' }], ['MAC', { numeric: '446', alpha2: 'MO' }], ['MDG', { numeric: '450', alpha2: 'MG' }], ['HUN', { numeric: '348', alpha2: 'HU' }], ['MKD', { numeric: '807', alpha2: 'MK' }], ['MYS', { numeric: '458', alpha2: 'MY' }], ['MWI', { numeric: '454', alpha2: 'MW' }], ['MDV', { numeric: '462', alpha2: 'MV' }], ['MLI', { numeric: '466', alpha2: 'ML' }], ['MLT', { numeric: '470', alpha2: 'MT' }], ['IMN', { numeric: '833', alpha2: 'IM' }], ['MAR', { numeric: '504', alpha2: 'MA' }], ['MHL', { numeric: '584', alpha2: 'MH' }], ['MTQ', { numeric: '474', alpha2: 'MQ' }], ['MUS', { numeric: '480', alpha2: 'MU' }], ['MRT', { numeric: '478', alpha2: 'MR' }], ['MYT', { numeric: '175', alpha2: 'YT' }], ['UMI', { numeric: '581', alpha2: 'UM' }], ['MEX', { numeric: '484', alpha2: 'MX' }], ['FSM', { numeric: '583', alpha2: 'FM' }], ['MDA', { numeric: '498', alpha2: 'MD' }], ['MCO', { numeric: '492', alpha2: 'MC' }], ['MNG', { numeric: '496', alpha2: 'MN' }], ['MSR', { numeric: '500', alpha2: 'MS' }], ['MOZ', { numeric: '508', alpha2: 'MZ' }], ['MMR', { numeric: '104', alpha2: 'MM' }], ['NAM', { numeric: '516', alpha2: 'NA' }], ['NRU', { numeric: '520', alpha2: 'NR' }], ['DEU', { numeric: '276', alpha2: 'DE' }], ['NPL', { numeric: '524', alpha2: 'NP' }], ['NER', { numeric: '562', alpha2: 'NE' }], ['NGA', { numeric: '566', alpha2: 'NG' }], ['NIC', { numeric: '558', alpha2: 'NI' }], ['NIU', { numeric: '570', alpha2: 'NU' }], ['NLD', { numeric: '528', alpha2: 'NL' }], ['NFK', { numeric: '574', alpha2: 'NF' }], ['NOR', { numeric: '578', alpha2: 'NO' }], ['NCL', { numeric: '540', alpha2: 'NC' }], ['NZL', { numeric: '554', alpha2: 'NZ' }], ['OMN', { numeric: '512', alpha2: 'OM' }], ['PAK', { numeric: '586', alpha2: 'PK' }], ['PLW', { numeric: '585', alpha2: 'PW' }], ['PSE', { numeric: '275', alpha2: 'PS' }], ['PAN', { numeric: '591', alpha2: 'PA' }], ['PNG', { numeric: '598', alpha2: 'PG' }], ['PRY', { numeric: '600', alpha2: 'PY' }], ['PER', { numeric: '604', alpha2: 'PE' }], ['PCN', { numeric: '612', alpha2: 'PN' }], ['CIV', { numeric: '384', alpha2: 'CI' }], ['POL', { numeric: '616', alpha2: 'PL' }], ['PRI', { numeric: '630', alpha2: 'PR' }], ['PRT', { numeric: '620', alpha2: 'PT' }], ['AUT', { numeric: '040', alpha2: 'AT' }], ['REU', { numeric: '638', alpha2: 'RE' }], ['GNQ', { numeric: '226', alpha2: 'GQ' }], ['ROU', { numeric: '642', alpha2: 'RO' }], ['RUS', { numeric: '643', alpha2: 'RU' }], ['RWA', { numeric: '646', alpha2: 'RW' }], ['GRC', { numeric: '300', alpha2: 'GR' }], ['SPM', { numeric: '666', alpha2: 'PM' }], ['SLV', { numeric: '222', alpha2: 'SV' }], ['WSM', { numeric: '882', alpha2: 'WS' }], ['SMR', { numeric: '674', alpha2: 'SM' }], ['SAU', { numeric: '682', alpha2: 'SA' }], ['SEN', { numeric: '686', alpha2: 'SN' }], ['PRK', { numeric: '408', alpha2: 'KP' }], ['MNP', { numeric: '580', alpha2: 'MP' }], ['SYC', { numeric: '690', alpha2: 'SC' }], ['SLE', { numeric: '694', alpha2: 'SL' }], ['SGP', { numeric: '702', alpha2: 'SG' }], ['SVK', { numeric: '703', alpha2: 'SK' }], ['SVN', { numeric: '705', alpha2: 'SI' }], ['SOM', { numeric: '706', alpha2: 'SO' }], ['ARE', { numeric: '784', alpha2: 'AE' }], ['GBR', { numeric: '826', alpha2: 'GB' }], ['USA', { numeric: '840', alpha2: 'US' }], ['SRB', { numeric: '688', alpha2: 'RS' }], ['CAF', { numeric: '140', alpha2: 'CF' }], ['SDN', { numeric: '729', alpha2: 'SD' }], ['SUR', { numeric: '740', alpha2: 'SR' }], ['SHN', { numeric: '654', alpha2: 'SH' }], ['LCA', { numeric: '662', alpha2: 'LC' }], ['BLM', { numeric: '652', alpha2: 'BL' }], ['KNA', { numeric: '659', alpha2: 'KN' }], ['MAF', { numeric: '663', alpha2: 'MF' }], ['SXM', { numeric: '534', alpha2: 'SX' }], ['STP', { numeric: '678', alpha2: 'ST' }], ['VCT', { numeric: '670', alpha2: 'VC' }], ['SWZ', { numeric: '748', alpha2: 'SZ' }], ['SYR', { numeric: '760', alpha2: 'SY' }], ['SLB', { numeric: '090', alpha2: 'SB' }], ['ESP', { numeric: '724', alpha2: 'ES' }], ['SJM', { numeric: '744', alpha2: 'SJ' }], ['LKA', { numeric: '144', alpha2: 'LK' }], ['SWE', { numeric: '752', alpha2: 'SE' }], ['CHE', { numeric: '756', alpha2: 'CH' }], ['TJK', { numeric: '762', alpha2: 'TJ' }], ['TZA', { numeric: '834', alpha2: 'TZ' }], ['THA', { numeric: '764', alpha2: 'TH' }], ['TWN', { numeric: '158', alpha2: 'TW' }], ['TGO', { numeric: '768', alpha2: 'TG' }], ['TKL', { numeric: '772', alpha2: 'TK' }], ['TON', { numeric: '776', alpha2: 'TO' }], ['TTO', { numeric: '780', alpha2: 'TT' }], ['TUN', { numeric: '788', alpha2: 'TN' }], ['TUR', { numeric: '792', alpha2: 'TR' }], ['TKM', { numeric: '795', alpha2: 'TM' }], ['TCA', { numeric: '796', alpha2: 'TC' }], ['TUV', { numeric: '798', alpha2: 'TV' }], ['UGA', { numeric: '800', alpha2: 'UG' }], ['UKR', { numeric: '804', alpha2: 'UA' }], ['URY', { numeric: '858', alpha2: 'UY' }], ['UZB', { numeric: '860', alpha2: 'UZ' }], ['CXR', { numeric: '162', alpha2: 'CX' }], ['VUT', { numeric: '548', alpha2: 'VU' }], ['VAT', { numeric: '336', alpha2: 'VA' }], ['VEN', { numeric: '862', alpha2: 'VE' }], ['VNM', { numeric: '704', alpha2: 'VN' }], ['TLS', { numeric: '626', alpha2: 'TL' }], ['WLF', { numeric: '876', alpha2: 'WF' }], ['ZMB', { numeric: '894', alpha2: 'ZM' }], ['ESH', { numeric: '732', alpha2: 'EH' }], ['ZWE', { numeric: '716', alpha2: 'ZW' }]]);

/***/ }),

/***/ 212:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__dirname, global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_components_Alert_vue__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Guests_GuestDialog_vue__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__filters_date__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__filters_upperCase__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__filters_capitalize__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_polyglot__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_polyglot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_polyglot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_ls__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_ls___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_ls__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuetify_es5_util_colors__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuetify_es5_util_colors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vuetify_es5_util_colors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_sweetalert2__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils__ = __webpack_require__(2);















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_13_vue_sweetalert2__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_vue_polyglot___default.a, {
  defaultLanguage: 'cs',
  languagesAvailable: ['cs']
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].locales({
  'cs': __webpack_require__(326)
});


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_vue_ls___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuetify___default.a, {
  theme: {
    primary: '#35495d',
    accent: '#009ee2',
    secondary: '#34495e',
    info: __WEBPACK_IMPORTED_MODULE_12_vuetify_es5_util_colors___default.a.blue.lighten1,
    warning: __WEBPACK_IMPORTED_MODULE_12_vuetify_es5_util_colors___default.a.amber.darken2,
    error: __WEBPACK_IMPORTED_MODULE_12_vuetify_es5_util_colors___default.a.red.accent4,
    success: __WEBPACK_IMPORTED_MODULE_12_vuetify_es5_util_colors___default.a.green.lighten2
  }
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('date', __WEBPACK_IMPORTED_MODULE_7__filters_date__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('upper', __WEBPACK_IMPORTED_MODULE_8__filters_upperCase__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('capitalize', __WEBPACK_IMPORTED_MODULE_9__filters_capitalize__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].directive('title', {
  inserted: function inserted(el, binding) {
    document.title = binding.value;
  },
  update: function update(el, binding) {
    document.title = binding.value;
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

if (true) {
  global.__static = __webpack_require__(327).join(__dirname, '/static').replace(/\\/g, '\\\\');
}

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('app-alert', __WEBPACK_IMPORTED_MODULE_5__components_components_Alert_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('guest-dialog', __WEBPACK_IMPORTED_MODULE_6__components_Guests_GuestDialog_vue__["a" /* default */]);



var token = localStorage.getItem('token');
__WEBPACK_IMPORTED_MODULE_14__utils__["a" /* HTTP */].defaults.headers.common['Authorization'] = token;

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */]);
  },
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* store */],

  created: function created() {
    var _this = this;

    console.log('ROUTE', this.$route);
    var lang = this.$ls.get('active_language', '');
    if (lang.length === 0 && window.location.host === 'app.whoarrived.com') {
      lang = 'en';
    } else {
      lang = 'cs';
    }
    this.$polyglot.getLocale({ baseURL: 'static/i18n', lang: lang });

    var hotelName = localStorage.getItem('hotel_name');
    this.$store.commit('setUser', { uid: token, hotel: hotelName });

    var lastUrl = this.$ls.get('last_url', '/');

    if (this.$route.query.page) {
      lastUrl = '/' + this.$route.query.page;
    } else if (token && token !== null && token.length && lastUrl === '/') {
      lastUrl = '/search';
    }
    this.$router.push(lastUrl);
    this.$router.beforeEach(function (to, from, next) {
      var token = localStorage.getItem('token');
      if (to.path === '/' && token !== null && token.length > 0) {
        next('/search');
      } else {
        next();
      }
    });

    this.$router.afterEach(function (to, from) {
      _this.$ls.set('last_url', to.path);
    });

    __WEBPACK_IMPORTED_MODULE_14__utils__["a" /* HTTP */].get('profile').then(function (response) {
      var data = response.data;
      _this.$store.commit('setUser', data);
    }).catch(function (error) {
      console.log('Profile ERROR: ' + error);
    });
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "/", __webpack_require__(7)))

/***/ }),

/***/ 216:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(33);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_225192f6_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(217)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_225192f6_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_225192f6_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 217:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 272:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('guest-dialog',{attrs:{"showDialog":_vm.showDialog},on:{"closeDialog":function($event){_vm.showDialog = false}}}),_vm._v(" "),_c('v-navigation-drawer',{attrs:{"app":"","fixed":"","clipped":"","temporary":""},model:{value:(_vm.sideNav),callback:function ($$v) {_vm.sideNav=$$v},expression:"sideNav"}},[_c('v-list',[_c('v-list-tile',[_c('v-list-tile-action',{attrs:{"color":"primary"}},[_c('router-link',{staticStyle:{"cursor":"pointer"},attrs:{"to":"/","tag":"span"}},[_vm._v(_vm._s(_vm.$t("app_title")))])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),(_vm.userIsAuthenticated)?_c('v-list-tile',{on:{"click":function($event){$event.stopPropagation();_vm.showDialog = true}}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("person_add")])],1),_vm._v(" "),_c('v-list-tile-content',[_vm._v(_vm._s(_vm.$t("add_guest")))])],1):_vm._e(),_vm._v(" "),_vm._l((_vm.menuItems),function(item){return _c('v-list-tile',{key:item.title,attrs:{"to":item.link}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v(_vm._s(item.icon))])],1),_vm._v(" "),_c('v-list-tile-content',[_vm._v(_vm._s(item.title))])],1)}),_vm._v(" "),_c('v-list-group',[_c('v-list-tile',{attrs:{"slot":"item"},slot:"item"},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("language")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.$t("localization")))])],1),_vm._v(" "),_c('v-list-tile-action',[_c('v-icon',[_vm._v("keyboard_arrow_down")])],1)],1),_vm._v(" "),_vm._l((_vm.defaultLangs),function(lang){return _c('v-list-tile',{key:lang.iso,on:{"click":function($event){return _vm.setActiveLanguage(lang.code)}}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.$t(lang.name)))])],1),_vm._v(" "),_c('v-list-tile-action',[_c('img',{attrs:{"src":_vm.getCountryFlagUrl(lang.iso),"alt":lang.name,"width":"24px"}})])],1)})],2),_vm._v(" "),(_vm.userIsAuthenticated)?_c('v-list-tile',{on:{"click":_vm.onLogout}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("power_settings_new")])],1),_vm._v(" "),_c('v-list-tile-content',[_vm._v(_vm._s(_vm.$t("logout")))])],1):_vm._e()],2)],1),_vm._v(" "),_c('v-toolbar',{staticClass:"primary elevation-4",attrs:{"app":"","dark":"","fixed":"","dense":"","clipped-left":""}},[_c('v-toolbar-side-icon',{staticClass:"hidden-md-and-up",on:{"click":function($event){$event.stopPropagation();_vm.sideNav = !_vm.sideNav}}}),_vm._v(" "),_c('v-toolbar-title',[_c('v-list',{staticClass:"pa-0 ma-0",staticStyle:{"background-color":"transparent"},attrs:{"two-line":""}},[_c('v-list-tile',[_c('v-list-tile-action',[_c('router-link',{staticStyle:{"cursor":"pointer"},attrs:{"to":"/","tag":"span"}},[_c('img',{staticClass:"pa-1 mt-1 mr-2",staticStyle:{"height":"44px"},attrs:{"src":"static/img/wa_logo.png"}})])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"white--text",staticStyle:{"height":"auto"}},[_c('router-link',{staticStyle:{"cursor":"pointer"},attrs:{"to":"/","tag":"span"}},[_c('h3',{staticClass:"ma-0"},[_vm._v(_vm._s(_vm._f("upper")(_vm.$t("app_title"))))])])],1),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:"white--text"},[_c('small',[_c('a',{staticStyle:{"text-decoration":"none"},attrs:{"href":"https://www.better-hotel.com","target":"_blank"}},[_vm._v("BY BETTER-HOTEL.COM")])])])],1)],1)],1)],1),_vm._v(" "),(_vm.userIsAuthenticated)?_c('v-spacer'):_vm._e(),_vm._v(" "),(_vm.userIsAuthenticated)?_c('v-toolbar-items',{staticClass:"hidden-sm-and-down"},[_c('v-btn',{attrs:{"flat":"","to":"/search"}},[_c('v-icon',{staticClass:"pr-1",attrs:{"right":"","dark":""}},[_vm._v("search")]),_vm._v("\n        "+_vm._s(_vm._f("upper")(_vm.$t("search")))+"\n      ")],1),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","to":"/profile-guests"}},[_c('v-icon',{staticClass:"pr-1",attrs:{"right":"","dark":""}},[_vm._v("list")]),_vm._v("\n        "+_vm._s(_vm._f("upper")(_vm.$t("your_records")))+"\n      ")],1)],1):_vm._e(),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.userIsAuthenticated)?_c('v-toolbar-items',{staticClass:"hidden-sm-and-down"},[_c('v-btn',{attrs:{"flat":""},on:{"click":_vm.doShare}},[_c('v-icon',{staticClass:"pr-1",attrs:{"right":"","dark":""}},[_vm._v("share")]),_vm._v("\n        "+_vm._s(_vm._f("upper")(_vm.$t("share")))+"\n      ")],1),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},on:{"click":_vm.about}},[_c('v-icon',{staticClass:"pr-1",attrs:{"right":"","dark":""}},[_vm._v("info_outline")]),_vm._v("\n        "+_vm._s(_vm._f("upper")(_vm.$t("about")))+"\n      ")],1),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){$event.stopPropagation();_vm.showDialog = true}}},[_c('v-btn',{staticClass:"ma-1",attrs:{"color":"accent"},nativeOn:{"click":function($event){$event.stopPropagation();_vm.showDialog = true}}},[_vm._v("\n          "+_vm._s(_vm._f("upper")(_vm.$t("add_guest")))+"\n        ")])],1)],1):_vm._e(),_vm._v(" "),(_vm.userIsAuthenticated)?_c('v-btn',{staticClass:"hidden-md-and-up",attrs:{"icon":""},nativeOn:{"click":function($event){$event.stopPropagation();_vm.showDialog = true}}},[_c('v-icon',[_vm._v("person_add")])],1):_vm._e(),_vm._v(" "),(_vm.userIsAuthenticated)?_c('v-spacer',{staticClass:"hidden-sm-and-down"}):_vm._e(),_vm._v(" "),(_vm.userIsAuthenticated)?_c('v-toolbar-items',{staticClass:"hidden-sm-and-down"},[_c('v-menu',{attrs:{"open-on-hover":"","bottom":"","offset-y":""}},[_c('v-btn',{attrs:{"slot":"activator","flat":""},slot:"activator"},[_vm._v("\n          "+_vm._s(_vm.hotel_name)+"\n          "),_c('v-icon',{attrs:{"center":"","dark":""}},[_vm._v("keyboard_arrow_down")])],1),_vm._v(" "),_c('v-list',[_c('v-list-tile',{attrs:{"to":"/profile"}},[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.$t("profile")))])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":_vm.onLogout}},[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.$t("logout")))])],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_vm._l((_vm.defaultLangs),function(lang){return _c('v-list-tile',{key:lang.iso,on:{"click":function($event){return _vm.setActiveLanguage(lang.code)}}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.$t(lang.name)))])],1),_vm._v(" "),_c('v-list-tile-action',[_c('img',{attrs:{"src":_vm.getCountryFlagUrl(lang.iso),"alt":lang.name,"width":"24px"}})])],1)})],2)],1)],1):_c('v-toolbar-items',{staticClass:"hidden-sm-and-down"},[_c('v-menu',{attrs:{"open-on-hover":"","bottom":"","offset-y":""}},[_c('v-btn',{attrs:{"slot":"activator","flat":""},slot:"activator"},[_c('v-icon',{attrs:{"center":"","dark":""}},[_vm._v("home")])],1),_vm._v(" "),_c('v-list',[_c('v-list-tile',{attrs:{"to":"/signin"}},[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.$t("signin")))])],1),_vm._v(" "),_c('v-list-tile',{attrs:{"to":"/signup"}},[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.$t("signup")))])],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list-tile',{on:{"click":_vm.about}},[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.$t("about")))])],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_vm._l((_vm.defaultLangs),function(lang){return _c('v-list-tile',{key:lang.iso,on:{"click":function($event){return _vm.setActiveLanguage(lang.code)}}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.$t(lang.name)))])],1),_vm._v(" "),_c('v-list-tile-action',[_c('img',{attrs:{"src":_vm.getCountryFlagUrl(lang.iso),"alt":lang.name,"width":"24px"}})])],1)})],2)],1)],1)],1),_vm._v(" "),_c('v-content',{staticStyle:{"background-color":"#ecf0f1"}},[_c('router-view',{directives:[{name:"title",rawName:"v-title",value:(_vm.$t('app_title')),expression:"$t('app_title')"}]})],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ 274:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = (function (to, from, next) {
  var token = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* HTTP */].defaults.headers.common['Authorization'];


  if (token === null || token === undefined || !token || !token.length) {
    next('/signin');
  } else {
    next();
  }
});

/***/ }),

/***/ 275:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About_vue__ = __webpack_require__(57);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47941b92_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47941b92_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47941b92_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 276:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_vm._v("\n  About ...\n")])}
var staticRenderFns = []


/***/ }),

/***/ 277:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__ = __webpack_require__(58);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e8cff354_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(278)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e8cff354"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e8cff354_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e8cff354_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 278:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 285:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"maxwidth"},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-toolbar',{staticClass:"white",attrs:{"card":"","prominent":""}},[_c('v-toolbar-title',{staticClass:"mt-3 body-4 primary--text"},[_c('h5',[_vm._v(_vm._s(_vm.profile.hotel))])])],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',{staticClass:"pa-4"},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_vm._v("\n              "+_vm._s(_vm.profile.name)+"\n            ")])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_vm._v("\n              "+_vm._s(_vm.profile.email)+"\n            ")])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('a',{attrs:{"href":_vm.getHrefUrl()}},[_vm._v(_vm._s(_vm.profile.hotel_url))])])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_vm._v("\n              "+_vm._s(_vm.profile.hotel_city)+"\n            ")])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","align-baseline":""}},[_c('v-avatar',{staticClass:"mr-2",attrs:{"tile":"","size":"32px"}},[_c('img',{attrs:{"src":_vm.countryFlag()}})]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.countryName()))])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_vm._v("\n              "+_vm._s(_vm.$t("api_key"))+": "+_vm._s(_vm.user.uid)+"\n            ")])],1),_vm._v(" "),_c('h3',{staticClass:"mt-5"},[_vm._v(_vm._s(_vm.$t("password_change")))]),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","md8":"","lg4":""}},[_c('v-text-field',{attrs:{"label":_vm.$t('password'),"type":"password","rules":[function () { return _vm.password.length >= 5 || _vm.$t('enter_at_least_5_characters'); }],"required":""},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","md8":"","lg4":""}},[_c('v-text-field',{attrs:{"label":_vm.$t('password_confirm'),"type":"password","rules":[_vm.comparePasswords]},model:{value:(_vm.confirmPassword),callback:function ($$v) {_vm.confirmPassword=$$v},expression:"confirmPassword"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","md8":"","lg4":""}},[_c('v-btn',{attrs:{"disabled":_vm.loading || !_vm.validPassword,"loading":_vm.loading},on:{"click":_vm.changePassword}},[_vm._v("\n                "+_vm._s(_vm.$t("password_change"))+"\n                "),_c('span',{staticClass:"custom-loader",attrs:{"slot":"loader"},slot:"loader"},[_c('v-icon',{attrs:{"light":""}},[_vm._v("cached")])],1)])],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ 286:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProfileGuests_vue__ = __webpack_require__(61);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_951a9fc4_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProfileGuests_vue__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProfileGuests_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_951a9fc4_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProfileGuests_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_951a9fc4_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProfileGuests_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 287:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 288:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GuestDetail_vue__ = __webpack_require__(64);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e96e8d8a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GuestDetail_vue__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(289)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e96e8d8a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GuestDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e96e8d8a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GuestDetail_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e96e8d8a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GuestDetail_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 289:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 290:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.reasonTags),function(tag){return _c('v-tooltip',{key:tag,staticClass:"mr-1",attrs:{"top":""}},[_c('v-chip',{attrs:{"slot":"activator","outline":"","color":"red lighten-1"},slot:"activator"},[_c('img',{attrs:{"src":_vm.getTagIconUrl(tag),"alt":_vm.getTagIconText(tag),"width":"24px"}})]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.getTagName(tag)))])],1)}),1)}
var staticRenderFns = []


/***/ }),

/***/ 291:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"persistent":"","scrollable":"","max-width":"900px"},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.closeDialog($event)}},model:{value:(_vm.showDialog),callback:function ($$v) {_vm.showDialog=$$v},expression:"showDialog"}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary elevation-4",attrs:{"dark":""}},[_c('h2',{staticClass:"pt-1"},[_vm._v(_vm._s(_vm.guestName))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},on:{"click":_vm.closeDialog}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',{staticClass:"ma-0 pa-0 grey--text"},[_c('v-container',{staticClass:"ma-0 pa-0",attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"pa-4 elevation-3",attrs:{"xs12":"","md7":""}},[_c('h4',{staticClass:"accent--text"},[_vm._v(_vm._s(_vm._f("upper")(_vm.$t("contact_data"))))]),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"secondary--text",attrs:{"xs6":""}},[_c('b',[_vm._v(_vm._s(_vm.$t("document_id")))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_vm._v("\n                "+_vm._s(_vm.guest && _vm.guest.document_id)+"\n              ")])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"secondary--text",attrs:{"xs6":""}},[_c('b',[_vm._v(_vm._s(_vm.$t("email")))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_vm._v("\n                "+_vm._s(_vm.guest && _vm.guest.email)+"\n              ")])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"secondary--text",attrs:{"xs6":""}},[_c('b',[_vm._v(_vm._s(_vm.$t("phone")))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_vm._v("\n                "+_vm._s(_vm.guest && _vm.guest.phone)+"\n              ")])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"secondary--text",attrs:{"xs6":""}},[_c('b',[_vm._v(_vm._s(_vm.$t("country")))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('img',{attrs:{"src":_vm.getCountryFlagUrl(_vm.guest && _vm.guest.country),"width":"20px"}}),_vm._v("\n                "+_vm._s(_vm.guestCountryName)+"\n              ")])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"secondary--text",attrs:{"xs6":""}},[_c('b',[_vm._v(_vm._s(_vm.$t("city")))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_vm._v("\n                "+_vm._s(_vm.guest && _vm.guest.city)+"\n              ")])],1),_vm._v(" "),_c('h4',{staticClass:"mt-4 accent--text"},[_vm._v(_vm._s(_vm._f("upper")(_vm.$t("reported_by"))))]),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"secondary--text",attrs:{"xs6":""}},[_c('b',[_vm._v(_vm._s(_vm.$t("hotel_name")))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('a',{attrs:{"href":_vm.getHotelUrl(_vm.guest),"target":"_blank"}},[_vm._v(_vm._s(_vm.guest && _vm.guest.hotel_name))])])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"secondary--text",attrs:{"xs6":""}},[_c('b',[_vm._v(_vm._s(_vm.$t("email")))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_vm._v("\n                "+_vm._s(_vm.guest && _vm.guest.hotel_email)+"\n              ")])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"secondary--text",attrs:{"xs6":""}},[_c('b',[_vm._v(_vm._s(_vm.$t("city")))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('img',{attrs:{"src":_vm.getCountryFlagUrl(_vm.guest && _vm.guest.hotel_country),"alt":"guest.hotel_country","width":"20px"}}),_vm._v(" "+_vm._s(_vm.guest && _vm.guest.hotel_city)+"\n              ")])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"secondary--text",attrs:{"xs6":""}},[_c('b',[_vm._v(_vm._s(_vm.$t("date")))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_vm._v("\n                "+_vm._s(_vm._f("date")(_vm.guest && _vm.guest.created_at))+"\n              ")])],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"pa-4 blue-grey--text",attrs:{"xs12":"","md5":""}},[_c('h4',{staticClass:"accent--text"},[_vm._v(_vm._s(_vm._f("upper")(_vm.$t("report_reasons"))))]),_vm._v(" "),_c('TagReasonsList',{attrs:{"tags":_vm.guestTags}}),_vm._v(" "),_c('v-textarea',{staticClass:"mt-4",attrs:{"full-width":"","rows":10,"single-line":"","readonly":""},model:{value:(_vm.guestNote),callback:function ($$v) {_vm.guestNote=$$v},expression:"guestNote"}})],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ 292:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('v-layout',{staticClass:"mb-2 mx-3 primary--text",attrs:{"row":"","wrap":"","hidden-md-and-down":""}},[_c('v-flex',{staticClass:"text-xs-left text-lg-center",attrs:{"xs4":"","md2":"","lg1":"","order-xs3":"","order-md1":"","order-lg1":""}},[_vm._v(_vm._s(_vm._f("upper")(_vm.$t("validity"))))]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-left text-lg-center",attrs:{"xs4":"","md1":"","lg1":"","order-xs4":"","order-md2":"","order-lg2":""}},[_vm._v(_vm._s(_vm._f("upper")(_vm.$t("compliance"))))]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-left",attrs:{"xs6":"","md3":"","lg1":"","order-xs1":"","order-md3":"","order-lg3":""}},[_vm._v(_vm._s(_vm._f("upper")(_vm.$t("id"))))]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-left",attrs:{"xs6":"","md3":"","lg3":"","order-xs2":"","order-md4":"","order-lg4":""}},[_vm._v(_vm._s(_vm._f("upper")(_vm.$t("name"))))]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-left",attrs:{"xs12":"","md12":"","lg5":"","order-xs6":"","order-md6":"","order-lg5":""}},[_vm._v(_vm._s(_vm._f("upper")(_vm.$t("report_reason"))))]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs4":"","md3":"","lg1":"","order-xs5":"","order-md5":"","order-lg6":""}},[_vm._v(_vm._s(_vm._f("upper")(_vm.$t("reported_by"))))])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.guests),function(guest,index){return _c('v-flex',{key:guest.id,attrs:{"xs12":""}},[_c('v-card',{staticStyle:{"cursor":"pointer"},attrs:{"flat":""},on:{"!click":function($event){return _vm.showDetailDialog(index)}}},[_c('v-card-text',[_c('v-layout',{staticClass:"primary--text",attrs:{"row":"","wrap":"","fill-height":"","align-center":""}},[_c('v-flex',{staticClass:"text-xs-left text-md-center",attrs:{"xs4":"","md2":"","lg1":"","order-xs3":"","order-md1":"","order-lg1":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-btn',{class:guest.positive > 0 ? 'green--text text--lighten-1' : 'grey--text text-lighten-2',attrs:{"icon":""},on:{"click":function($event){$event.stopPropagation();return _vm.confirmVote(guest, 'positive')}}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("thumb_up")]),_vm._v(" "),_c('span',{staticClass:"pl-1"},[_vm._v(_vm._s(guest.positive))])],1),_vm._v(" "),_c('v-btn',{class:guest.negative > 0 ? 'red--text text--lighten-1' : 'grey--text text-lighten-2',attrs:{"icon":""},on:{"click":function($event){$event.stopPropagation();return _vm.confirmVote(guest, 'negative')}}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("thumb_down")]),_vm._v(" "),_c('span',{staticClass:"pl-1"},[_vm._v(_vm._s(guest.negative))])],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-left text-md-center",attrs:{"xs4":"","md1":"","lg1":"","order-xs4":"","order-md2":"","order-lg2":""}},[_c('v-chip',{staticClass:"red white--text"},[_vm._v(_vm._s(guest.validity)+"%")])],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-left",attrs:{"xs6":"","md3":"","lg1":"","order-xs1":"","order-md3":"","order-lg3":""}},[_c('v-layout',{attrs:{"row":"","hidden-md-and-down":""}},[_vm._v("\n                "+_vm._s(guest.document_id)+"\n              ")]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","hidden-lg-and-up":""}},[_c('span',[_vm._v(_vm._s(_vm._f("upper")(_vm.$t("id")))+":")]),_vm._v(" "+_vm._s(guest.document_id)+"\n              ")])],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-left",attrs:{"xs6":"","md3":"","lg3":"","order-xs2":"","order-md4":"","order-lg4":""}},[_c('v-layout',{attrs:{"row":"","hidden-md-and-down":""}},[_c('strong',[_vm._v(_vm._s(guest.last_name + ' ' + guest.first_name))])]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","hidden-lg-and-up":""}},[_c('span',[_vm._v(_vm._s(_vm.$t("name"))+": ")]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(guest.last_name + ' ' + guest.first_name))])])],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-left",attrs:{"xs12":"","md12":"","lg5":"","order-xs6":"","order-md6":"","order-lg5":""}},[_c('TagReasonsList',{attrs:{"tags":guest.tags}}),_vm._v(" "),_c('p',{staticClass:"mr-2 mb-0 truncate"},[_vm._v(_vm._s(guest.note))])],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs4":"","md3":"","lg1":"","order-xs5":"","order-md5":"","order-lg6":"","align-center":""}},[_c('v-layout',{attrs:{"row":"","fill-height":"","align-center":""}},[_c('v-flex',{attrs:{"xs11":""}},[_vm._v("\n                  "+_vm._s(_vm._f("date")(guest.created_at,true))+" "),_c('img',{attrs:{"src":_vm.getCountryFlagUrl(guest.hotel_country),"alt":"guest.hotel_country","width":"16px"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"truncate"},[_c('v-tooltip',{attrs:{"top":""}},[_c('span',{attrs:{"slot":"activator"},slot:"activator"},[_vm._v(_vm._s(guest.hotel_name))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(guest.hotel_name))])])],1)]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":""}},[_c('v-menu',{attrs:{"open-on-hover":""}},[_c('v-btn',{attrs:{"slot":"activator","dark":"","fab":"","small":"","color":"blue-grey"},slot:"activator"},[_c('v-icon',[_vm._v("more_vert")])],1),_vm._v(" "),_c('v-list',[_c('v-list-tile',{on:{"click":function($event){return _vm.showDetailDialog(index)}}},[_c('v-list-tile-title',[_c('v-icon',[_vm._v("info")]),_vm._v("\n                          "+_vm._s(_vm.$t("guest_detail"))+"\n                        ")],1)],1),_vm._v(" "),(guest.creator_id === _vm.user.id)?_c('v-list-tile',{on:{"click":function($event){return _vm.editGuest(index)}}},[_c('v-list-tile-title',[_c('v-icon',[_vm._v("edit")]),_vm._v("\n                          "+_vm._s(_vm.$t("guest_edit"))+"\n                        ")],1)],1):_vm._e()],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),(index < _vm.guests.length - 1)?_c('v-divider'):_vm._e()],1)}),1),_vm._v(" "),_c('guest-dialog',{attrs:{"showDialog":_vm.showDialog,"guest":_vm.editedGuest},on:{"closeDialog":_vm.closeDialog}}),_vm._v(" "),_c('GuestDetail',{attrs:{"showDialog":_vm.showGuestDetailDialog,"guest":_vm.editedGuest},on:{"closeDialog":_vm.closeDetailDialog}})],1)}
var staticRenderFns = []


/***/ }),

/***/ 294:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',{staticClass:"mt-3",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","md10":"","lg8":"","offset-md1":"","offset-lg2":""}},[_c('h2',[_vm._v(_vm._s(_vm.$t("your_records")))])])],1),_vm._v(" "),(_vm.filter_guests.length)?_c('v-layout',{staticClass:"mt-1 mb-1",attrs:{"row":""}},[_c('v-flex',{staticClass:"pa-3 white",attrs:{"xs12":"","md10":"","lg8":"","offset-md1":"","offset-lg2":"","elevation-15":""}},[_c('v-layout',[_c('v-flex',{attrs:{"xs12":""}},[_c('b',[_c('v-text-field',{ref:"focus",attrs:{"label":_vm.$t('search_your_guests'),"single-line":"","full-width":"","hide-details":true,"prepend-icon":"search","append-icon":"clear","append-icon-cb":_vm.clearFilter},on:{"input":_vm.onFilter},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}})],1)])],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-layout',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"mt-3",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","text-xs-center":""}},[_c('v-progress-circular',{staticClass:"primary--text",attrs:{"indeterminate":"","size":60,"width":4}})],1)],1),_vm._v(" "),_c('v-layout',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}],attrs:{"row":""}},[(!_vm.filter_guests.length)?_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":""}},[_c('v-container',{staticClass:"text--center"},[_vm._v("\n        "+_vm._s(_vm.$t("no_records_entered"))+"\n      ")])],1):_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{staticClass:"primary--text my-3"},[_c('v-flex',{staticClass:"text-xs-left",attrs:{"xs6":""}}),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs6":""}},[_c('strong',{staticClass:"text-xs-right"},[_vm._v(_vm._s(_vm.$t("total"))+" "+_vm._s(_vm.filter_guests.length))])])],1),_vm._v(" "),_c('guests-list',{attrs:{"guests":_vm.filter_guests,"editable":true}})],1)],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ 295:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Signin_vue__ = __webpack_require__(68);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72fff5b5_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Signin_vue__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Signin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72fff5b5_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Signin_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72fff5b5_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Signin_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 296:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('v-card',{staticClass:"card--flex-toolbar"},[_c('v-toolbar',{staticClass:"white",attrs:{"card":"","prominent":""}},[_c('v-toolbar-title',{staticClass:"body-4 primary--text"},[_vm._v(_vm._s(_vm.$t("please_signin")))])],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',[_c('v-container',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.onSignin($event)}}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{ref:"focus",attrs:{"name":"email","label":_vm.$t('email'),"id":"email","type":"email","required":"","autofocus":""},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"name":"password","label":_vm.$t('password'),"id":"password","type":"password","required":""},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"text-xs-left",attrs:{"xs6":""}},[_c('v-btn',{attrs:{"type":"submit","disabled":_vm.loading,"loading":_vm.loading}},[_vm._v("\n                    "+_vm._s(_vm.$t("signin"))+"\n                    "),_c('span',{staticClass:"custom-loader",attrs:{"slot":"loader"},slot:"loader"},[_c('v-icon',{attrs:{"light":""}},[_vm._v("cached")])],1)])],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs6":""}},[_c('router-link',{attrs:{"to":"/forget-password","disabled":_vm.loading}},[_vm._v("\n                    "+_vm._s(_vm.$t("forget_password"))+"\n                  ")])],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"mt-4",attrs:{"row":""}},[_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":""}},[_c('router-link',{attrs:{"to":"/signup","disabled":_vm.loading}},[_vm._v("\n                    "+_vm._s(_vm.$t("do_signup"))+"\n                  ")])],1)],1)],1)])],1)],1)],1)],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ 297:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Signup_vue__ = __webpack_require__(69);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3beb6f5d_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Signup_vue__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(298)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3beb6f5d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Signup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3beb6f5d_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Signup_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3beb6f5d_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Signup_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 298:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 299:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-autocomplete',{attrs:{"label":_vm.$t('country'),"items":_vm.countries,"item-text":"code","item-value":"code","filter":_vm.countryFilter,"rules":[function () { return !_vm.required || !!_vm.data || _vm.$t('required_field'); }],"required":_vm.required,"hide-details":_vm.hideDetails || !_vm.required},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_c('v-avatar',{staticClass:"mr-2",attrs:{"tile":"","size":"32px"}},[_c('img',{attrs:{"src":data.item.flag}})]),_vm._v(" "),_c('span',{staticClass:"black--text"},[_vm._v(_vm._s(_vm.$t("country_" + data.item.alpha2)))])]}},{key:"item",fn:function(data){return [_c('v-avatar',{staticClass:"mr-2",attrs:{"tile":""}},[_c('img',{attrs:{"src":data.item.flag}})]),_vm._v("\n      "+_vm._s(_vm.$t("country_" + data.item.alpha2))+"\n    ")]}}]),model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}})}
var staticRenderFns = []


/***/ }),

/***/ 300:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"max-width":"800px","max-height":"800px","scrollable":""},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.closeDialog($event)}},model:{value:(_vm.showDialog),callback:function ($$v) {_vm.showDialog=$$v},expression:"showDialog"}},[_c('v-card',[_c('v-card-title',[_c('h2',[_vm._v(_vm._s(_vm.$t("tac")))])]),_vm._v(" "),_c('v-card-text',{domProps:{"innerHTML":_vm._s(_vm.htmlTac)}}),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary darken-1","flat":"flat"},on:{"click":_vm.closeDialog}},[_vm._v(_vm._s(_vm.$t("close")))])],1)],1)],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ 301:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('v-card',{staticClass:"card--flex-toolbar"},[_c('v-toolbar',{staticClass:"white",attrs:{"card":"","prominent":""}},[_c('v-toolbar-title',{staticClass:"body-4 primary--text"},[_vm._v(_vm._s(_vm.$t("signup_form")))])],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',[_c('v-container',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.onSignup($event)}}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"name":"hotel","label":_vm.$t('hotel_name'),"id":"hotel","rules":[function () { return !!_vm.hotel || _vm.$t('required_field'); }],"required":"","autofocus":""},model:{value:(_vm.hotel),callback:function ($$v) {_vm.hotel=$$v},expression:"hotel"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"name":"hotel_url","label":_vm.$t('hotel_url'),"id":"hotel_url","rules":[function () { return !!_vm.hotel_url || _vm.$t('required_field'); }],"required":""},model:{value:(_vm.hotel_url),callback:function ($$v) {_vm.hotel_url=$$v},expression:"hotel_url"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"name":"hotel_person","label":_vm.$t('hotel_person'),"id":"hotel_person","rules":[function () { return !!_vm.hotel_person || _vm.$t('required_field'); }],"required":""},model:{value:(_vm.hotel_person),callback:function ($$v) {_vm.hotel_person=$$v},expression:"hotel_person"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"name":"hotel_city","label":_vm.$t('city'),"id":"hotel_city","rules":[function () { return !!_vm.hotel_city || _vm.$t('required_field'); }],"required":""},model:{value:(_vm.hotel_city),callback:function ($$v) {_vm.hotel_city=$$v},expression:"hotel_city"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('CountrySelect',{attrs:{"country":_vm.hotel_country},on:{"update:country":function($event){_vm.hotel_country=$event}}})],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"mt-4",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"name":"email","label":_vm.$t('email'),"id":"email","type":"email","required":""},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"name":"password","label":_vm.$t('password'),"id":"password","type":"password","rules":[function () { return _vm.password.length >= 5 || _vm.$t('enter_at_least_5_characters'); }],"required":""},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"name":"confirmPassword","label":_vm.$t('password_confirm'),"id":"confirmPassword","type":"password","rules":[_vm.comparePasswords]},model:{value:(_vm.confirmPassword),callback:function ($$v) {_vm.confirmPassword=$$v},expression:"confirmPassword"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs1":""}},[_c('v-checkbox',{attrs:{"color":"primary"},model:{value:(_vm.licence_agree),callback:function ($$v) {_vm.licence_agree=$$v},expression:"licence_agree"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"compress_lines grey--text lighten-2",attrs:{"xs11":""},on:{"click":function($event){$event.stopPropagation();_vm.showTacDialog = true}}},[_c('tac-dialog',{attrs:{"showDialog":_vm.showTacDialog},on:{"closeDialog":function($event){_vm.showTacDialog = false}}}),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.$t("user_licence_agree")))])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":""}},[_c('v-btn',{attrs:{"type":"submit","disabled":_vm.loading,"loading":_vm.loading}},[_vm._v("\n                    "+_vm._s(_vm.$t("signup"))+"\n                    "),_c('span',{staticClass:"custom-loader",attrs:{"slot":"loader"},slot:"loader"},[_c('v-icon',{attrs:{"light":""}},[_vm._v("cached")])],1)])],1)],1)],1)])],1)],1)],1)],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ 302:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7dff0795_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignupConfirm_vue__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7dff0795_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignupConfirm_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7dff0795_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignupConfirm_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 303:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"card--flex-toolbar"},[_c('v-toolbar',{staticClass:"white",attrs:{"card":"","prominent":""}},[_c('v-toolbar-title',{staticClass:"body-4 primary--text"},[_vm._v(_vm._s(_vm.$t("registration_confirm_title")))])],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_vm._v("\n              "+_vm._s(_vm.$t("registration_confirm_content"))+"\n            ")])],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ 304:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ForgetPassword_vue__ = __webpack_require__(74);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f525a83_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ForgetPassword_vue__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ForgetPassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f525a83_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ForgetPassword_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f525a83_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ForgetPassword_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 305:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('v-card',{staticClass:"card--flex-toolbar"},[_c('v-toolbar',{staticClass:"white",attrs:{"card":"","prominent":""}},[_c('v-toolbar-title',{staticClass:"body-4 primary--text"},[_vm._v(_vm._s(_vm.$t("forget_password")))])],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',[_c('v-container',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.createNewPassword($event)}}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"name":"email","label":_vm.$t('email'),"id":"email","type":"email","required":"","autofocus":""},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"text-xs-left",attrs:{"xs6":""}},[_c('v-btn',{attrs:{"type":"submit","disabled":_vm.loading,"loading":_vm.loading}},[_vm._v("\n                    "+_vm._s(_vm.$t("password_change"))+"\n                    "),_c('span',{staticClass:"custom-loader",attrs:{"slot":"loader"},slot:"loader"},[_c('v-icon',{attrs:{"light":""}},[_vm._v("cached")])],1)])],1)],1)],1)])],1)],1)],1)],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ 306:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Search_vue__ = __webpack_require__(75);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39e52820_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Search_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39e52820_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39e52820_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 307:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',{staticClass:"mt-3 mb-1",attrs:{"row":""}},[_c('v-flex',{staticClass:"pa-3 white",attrs:{"xs12":"","md10":"","lg8":"","offset-md1":"","offset-lg2":"","elevation-15":""}},[_c('v-layout',[_c('v-flex',{attrs:{"xs11":""}},[_c('b',[_c('v-text-field',{ref:"focus",attrs:{"name":"search","label":_vm.$t('search_blacklist'),"rules":[function () { return _vm.search.length > 2 || _vm.$t('enter_at_least_3_characters'); }],"single-line":"","full-width":"","hide-details":true,"prepend-icon":"search"},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.doSearch($event)}},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1)]),_vm._v(" "),_c('v-flex',{staticClass:"mt-1",attrs:{"xs1":""}},[(!_vm.loading && _vm.search.length > 2)?_c('v-btn',{attrs:{"icon":""},on:{"click":_vm.doSearch}},[_c('v-icon',[_vm._v("forward")])],1):_vm._e(),_vm._v(" "),(_vm.loading)?_c('v-progress-circular',{staticClass:"primary--text",attrs:{"indeterminate":""}}):_vm._e()],1)],1)],1)],1),_vm._v(" "),_c('v-container',{staticClass:"text-xs-center grey--text lighten-3"},[_vm._v("\n    "+_vm._s(_vm.$t("search_tips"))+"\n  ")]),_vm._v(" "),(_vm.searchPerformed && !_vm.loading)?_c('v-layout',{attrs:{"row":""}},[(!_vm.items.length)?_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":""}},[_c('v-container',{staticClass:"text--center"},[_vm._v("\n        "+_vm._s(_vm.$t("no_records_found"))+"\n      ")])],1):_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{staticClass:"primary--text my-3"},[_c('v-flex',{staticClass:"text-xs-left",attrs:{"xs6":""}},[_c('h3',[_c('strong',[_vm._v(_vm._s(_vm.$t("matches_found")))])])]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs6":""}},[_c('strong',{staticClass:"text-xs-right"},[_vm._v(_vm._s(_vm.$t("total"))+" "+_vm._s(_vm.items.length))])])],1),_vm._v(" "),_c('guests-list',{attrs:{"guests":_vm.items}})],1)],1):_vm._e()],1)}
var staticRenderFns = []


/***/ }),

/***/ 308:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(56);





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: {
    user: null
  },

  mutations: {
    setUser: function setUser(state, payload) {
      state.user = payload;

      __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* HTTP */].defaults.headers.common['Authorization'] = payload === null ? '' : payload.uid;
      if (payload !== null && payload.uid !== null) {
        localStorage.setItem('token', payload.uid);
        localStorage.setItem('hotel_name', payload.hotel);
      } else {
        localStorage.removeItem('token');
        localStorage.removeItem('hotel_name');
      }
    }
  },

  actions: {
    logout: function logout(_ref) {
      var commit = _ref.commit;

      commit('setUser', null);
      __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push('/signin');
    }
  },

  getters: {
    user: function user(state) {
      return state.user;
    }
  }
});

/***/ }),

/***/ 309:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Alert_vue__ = __webpack_require__(76);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d58eaac_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Alert_vue__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Alert_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d58eaac_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Alert_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d58eaac_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Alert_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 310:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{attrs:{"error":"","dismissible":"","value":true},on:{"input":_vm.onClose}},[_vm._v("\n  "+_vm._s(_vm.text)+"\n")])}
var staticRenderFns = []


/***/ }),

/***/ 311:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GuestDialog_vue__ = __webpack_require__(77);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1098d650_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GuestDialog_vue__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(312)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1098d650"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GuestDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1098d650_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GuestDialog_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1098d650_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GuestDialog_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 312:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 313:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TagReasonSelect_vue__ = __webpack_require__(78);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0948cf44_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TagReasonSelect_vue__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TagReasonSelect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0948cf44_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TagReasonSelect_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0948cf44_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TagReasonSelect_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 314:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"label":_vm.$t('report_reasons'),"item-text":"name","item-value":"code","multiple":"","chips":"","solo":"","clearable":"","hide-selected":"","required":_vm.required,"items":_vm.default_tags},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_c('v-tooltip',{attrs:{"top":""}},[_c('v-chip',{key:JSON.stringify(data.item),staticClass:"chip--select-multi",attrs:{"slot":"activator","close":"","outline":"","color":"red lighten-1","selected":data.selected},on:{"input":function($event){return data.parent.selectItem(data.item)}},slot:"activator"},[_c('img',{attrs:{"src":data.item.icon,"alt":data.item.icon_text,"width":"24px"}})]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.getTagName(data.item.code)))])],1)]}},{key:"item",fn:function(data){return [_c('img',{staticClass:"mr-3",attrs:{"src":data.item.icon,"alt":data.item.icon_text,"width":"24px"}}),_vm._v("\n    "+_vm._s(_vm.$t("tag_" + data.item.code))+"\n  ")]}}]),model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}})}
var staticRenderFns = []


/***/ }),

/***/ 315:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"persistent":"","scrollable":"","max-width":"900px"},model:{value:(_vm.showDialog),callback:function ($$v) {_vm.showDialog=$$v},expression:"showDialog"}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary elevation-4",attrs:{"dark":""}},[_c('h2',{staticClass:"pt-1"},[_vm._v(_vm._s(_vm.edditing ? _vm.$t("edit_guest") : _vm.$t("add_guest")))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.edditing)?_c('v-tooltip',{staticClass:"mr-3",attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":""},on:{"click":_vm.deleteGuest},slot:"activator"},[_c('v-icon',[_vm._v("delete")])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t("guest_delete_tooltip")))])],1):_vm._e(),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":""},on:{"click":_vm.closeDialog},slot:"activator"},[_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t("close")))])],1)],1),_vm._v(" "),_c('v-card-text',{staticClass:"ma-0 pa-0"},[_c('v-container',{staticClass:"ma-0 pa-0",attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"pa-4 grey lighten-4 elevation-3",attrs:{"xs12":"","md7":""}},[_c('h4',{staticClass:"accent--text"},[_vm._v(_vm._s(_vm._f("upper")(_vm.$t("guest_information"))))]),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"pr-3",attrs:{"xs6":""}},[_c('v-text-field',{ref:"focus",attrs:{"name":"first_name","label":_vm.$t('first_name'),"autofocus":""},model:{value:(_vm.first_name),callback:function ($$v) {_vm.first_name=$$v},expression:"first_name"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pl-3",attrs:{"xs6":""}},[_c('v-text-field',{attrs:{"name":"last_name","label":_vm.$t('last_name'),"rules":[function () { return !!_vm.last_name || _vm.$t('required_field'); }],"required":""},model:{value:(_vm.last_name),callback:function ($$v) {_vm.last_name=$$v},expression:"last_name"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"pr-3",attrs:{"xs6":""}},[_c('CountrySelect',{attrs:{"country":_vm.country,"required":true},on:{"update:country":function($event){_vm.country=$event}}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pl-3",attrs:{"xs6":""}},[_c('v-text-field',{attrs:{"name":"city","label":_vm.$t('city'),"rules":[function () { return !!_vm.city || _vm.$t('required_field'); }],"required":""},model:{value:(_vm.city),callback:function ($$v) {_vm.city=$$v},expression:"city"}})],1)],1),_vm._v(" "),_c('h4',{staticClass:"mt-4 accent--text"},[_c('b',[_vm._v(_vm._s(_vm._f("upper")(_vm.$t("unique_information"))))])]),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"pr-3",attrs:{"xs6":""}},[_c('v-text-field',{attrs:{"name":"document_id","label":_vm.$t('document_id')},model:{value:(_vm.document_id),callback:function ($$v) {_vm.document_id=$$v},expression:"document_id"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pl-3",attrs:{"xs6":""}},[_c('v-text-field',{attrs:{"name":"visum_number","label":_vm.$t('visum_number')},model:{value:(_vm.visum_number),callback:function ($$v) {_vm.visum_number=$$v},expression:"visum_number"}})],1)],1),_vm._v(" "),_c('h4',{staticClass:"mt-4 accent--text"},[_c('b',[_vm._v(_vm._s(_vm._f("upper")(_vm.$t("contact_data"))))])]),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"pr-3",attrs:{"xs6":""}},[_c('v-text-field',{attrs:{"name":"email","label":_vm.$t('email')},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pl-3",attrs:{"xs6":""}},[_c('v-text-field',{attrs:{"name":"phone","label":_vm.$t('phone')},model:{value:(_vm.phone),callback:function ($$v) {_vm.phone=$$v},expression:"phone"}})],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"pa-4",attrs:{"xs12":"","md5":""}},[_c('h4',{staticClass:"accent--text"},[_vm._v(_vm._s(_vm._f("upper")(_vm.$t("report_reason"))))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t("choose_report_reasons")))]),_vm._v(" "),_c('TagReasonSelect',{attrs:{"tags":_vm.tags,"required":true},on:{"update:tags":function($event){_vm.tags=$event}}}),_vm._v(" "),_c('p',{staticClass:"mt-3 accent--text"},[_vm._v(_vm._s(_vm._f("upper")(_vm.$t("your_note"))))]),_vm._v(" "),_c('v-textarea',{attrs:{"name":"note","label":_vm.$t('note'),"rows":10},model:{value:(_vm.note),callback:function ($$v) {_vm.note=$$v},expression:"note"}}),_vm._v(" "),_c('v-layout',{directives:[{name:"show",rawName:"v-show",value:(_vm.guest === null),expression:"guest === null"}],staticClass:"mt-3"},[_c('v-flex',{attrs:{"xs1":""}},[_c('v-checkbox',{attrs:{"color":"primary"},model:{value:(_vm.licence_agree),callback:function ($$v) {_vm.licence_agree=$$v},expression:"licence_agree"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs11":""}},[_c('small',{staticClass:"grey--text lighten-2"},[_c('b',[_c('tac-dialog',{attrs:{"showDialog":_vm.showTacDialog},on:{"closeDialog":function($event){_vm.showTacDialog = false}}}),_vm._v(" "),_c('p',{staticClass:"compress_lines",on:{"click":function($event){$event.stopPropagation();_vm.showTacDialog = true}}},[_vm._v(_vm._s(_vm.$t("licence_agree")))])],1)])])],1),_vm._v(" "),_c('v-btn',{staticClass:"mt-4",staticStyle:{"width":"100%"},attrs:{"color":"accent","dark":""},on:{"click":_vm.onSave}},[_vm._v("\n              "+_vm._s(_vm._f("upper")((_vm.guest === null ? _vm.$t("report_guest") : _vm.$t("update_guest"))))+"\n            ")])],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ 316:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);


/* harmony default export */ __webpack_exports__["a"] = (function (value) {
  var short = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var date = __WEBPACK_IMPORTED_MODULE_0_moment___default()(value);
  return date.format('DD.MM.YY' + (short ? '' : 'YY'));
});

/***/ }),

/***/ 317:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 79,
	"./af.js": 79,
	"./ar": 80,
	"./ar-dz": 81,
	"./ar-dz.js": 81,
	"./ar-kw": 82,
	"./ar-kw.js": 82,
	"./ar-ly": 83,
	"./ar-ly.js": 83,
	"./ar-ma": 84,
	"./ar-ma.js": 84,
	"./ar-sa": 85,
	"./ar-sa.js": 85,
	"./ar-tn": 86,
	"./ar-tn.js": 86,
	"./ar.js": 80,
	"./az": 87,
	"./az.js": 87,
	"./be": 88,
	"./be.js": 88,
	"./bg": 89,
	"./bg.js": 89,
	"./bm": 90,
	"./bm.js": 90,
	"./bn": 91,
	"./bn.js": 91,
	"./bo": 92,
	"./bo.js": 92,
	"./br": 93,
	"./br.js": 93,
	"./bs": 94,
	"./bs.js": 94,
	"./ca": 95,
	"./ca.js": 95,
	"./cs": 96,
	"./cs.js": 96,
	"./cv": 97,
	"./cv.js": 97,
	"./cy": 98,
	"./cy.js": 98,
	"./da": 99,
	"./da.js": 99,
	"./de": 100,
	"./de-at": 101,
	"./de-at.js": 101,
	"./de-ch": 102,
	"./de-ch.js": 102,
	"./de.js": 100,
	"./dv": 103,
	"./dv.js": 103,
	"./el": 104,
	"./el.js": 104,
	"./en-au": 105,
	"./en-au.js": 105,
	"./en-ca": 106,
	"./en-ca.js": 106,
	"./en-gb": 107,
	"./en-gb.js": 107,
	"./en-ie": 108,
	"./en-ie.js": 108,
	"./en-il": 109,
	"./en-il.js": 109,
	"./en-in": 110,
	"./en-in.js": 110,
	"./en-nz": 111,
	"./en-nz.js": 111,
	"./en-sg": 112,
	"./en-sg.js": 112,
	"./eo": 113,
	"./eo.js": 113,
	"./es": 114,
	"./es-do": 115,
	"./es-do.js": 115,
	"./es-us": 116,
	"./es-us.js": 116,
	"./es.js": 114,
	"./et": 117,
	"./et.js": 117,
	"./eu": 118,
	"./eu.js": 118,
	"./fa": 119,
	"./fa.js": 119,
	"./fi": 120,
	"./fi.js": 120,
	"./fil": 121,
	"./fil.js": 121,
	"./fo": 122,
	"./fo.js": 122,
	"./fr": 123,
	"./fr-ca": 124,
	"./fr-ca.js": 124,
	"./fr-ch": 125,
	"./fr-ch.js": 125,
	"./fr.js": 123,
	"./fy": 126,
	"./fy.js": 126,
	"./ga": 127,
	"./ga.js": 127,
	"./gd": 128,
	"./gd.js": 128,
	"./gl": 129,
	"./gl.js": 129,
	"./gom-deva": 130,
	"./gom-deva.js": 130,
	"./gom-latn": 131,
	"./gom-latn.js": 131,
	"./gu": 132,
	"./gu.js": 132,
	"./he": 133,
	"./he.js": 133,
	"./hi": 134,
	"./hi.js": 134,
	"./hr": 135,
	"./hr.js": 135,
	"./hu": 136,
	"./hu.js": 136,
	"./hy-am": 137,
	"./hy-am.js": 137,
	"./id": 138,
	"./id.js": 138,
	"./is": 139,
	"./is.js": 139,
	"./it": 140,
	"./it-ch": 141,
	"./it-ch.js": 141,
	"./it.js": 140,
	"./ja": 142,
	"./ja.js": 142,
	"./jv": 143,
	"./jv.js": 143,
	"./ka": 144,
	"./ka.js": 144,
	"./kk": 145,
	"./kk.js": 145,
	"./km": 146,
	"./km.js": 146,
	"./kn": 147,
	"./kn.js": 147,
	"./ko": 148,
	"./ko.js": 148,
	"./ku": 149,
	"./ku.js": 149,
	"./ky": 150,
	"./ky.js": 150,
	"./lb": 151,
	"./lb.js": 151,
	"./lo": 152,
	"./lo.js": 152,
	"./lt": 153,
	"./lt.js": 153,
	"./lv": 154,
	"./lv.js": 154,
	"./me": 155,
	"./me.js": 155,
	"./mi": 156,
	"./mi.js": 156,
	"./mk": 157,
	"./mk.js": 157,
	"./ml": 158,
	"./ml.js": 158,
	"./mn": 159,
	"./mn.js": 159,
	"./mr": 160,
	"./mr.js": 160,
	"./ms": 161,
	"./ms-my": 162,
	"./ms-my.js": 162,
	"./ms.js": 161,
	"./mt": 163,
	"./mt.js": 163,
	"./my": 164,
	"./my.js": 164,
	"./nb": 165,
	"./nb.js": 165,
	"./ne": 166,
	"./ne.js": 166,
	"./nl": 167,
	"./nl-be": 168,
	"./nl-be.js": 168,
	"./nl.js": 167,
	"./nn": 169,
	"./nn.js": 169,
	"./oc-lnc": 170,
	"./oc-lnc.js": 170,
	"./pa-in": 171,
	"./pa-in.js": 171,
	"./pl": 172,
	"./pl.js": 172,
	"./pt": 173,
	"./pt-br": 174,
	"./pt-br.js": 174,
	"./pt.js": 173,
	"./ro": 175,
	"./ro.js": 175,
	"./ru": 176,
	"./ru.js": 176,
	"./sd": 177,
	"./sd.js": 177,
	"./se": 178,
	"./se.js": 178,
	"./si": 179,
	"./si.js": 179,
	"./sk": 180,
	"./sk.js": 180,
	"./sl": 181,
	"./sl.js": 181,
	"./sq": 182,
	"./sq.js": 182,
	"./sr": 183,
	"./sr-cyrl": 184,
	"./sr-cyrl.js": 184,
	"./sr.js": 183,
	"./ss": 185,
	"./ss.js": 185,
	"./sv": 186,
	"./sv.js": 186,
	"./sw": 187,
	"./sw.js": 187,
	"./ta": 188,
	"./ta.js": 188,
	"./te": 189,
	"./te.js": 189,
	"./tet": 190,
	"./tet.js": 190,
	"./tg": 191,
	"./tg.js": 191,
	"./th": 192,
	"./th.js": 192,
	"./tk": 193,
	"./tk.js": 193,
	"./tl-ph": 194,
	"./tl-ph.js": 194,
	"./tlh": 195,
	"./tlh.js": 195,
	"./tr": 196,
	"./tr.js": 196,
	"./tzl": 197,
	"./tzl.js": 197,
	"./tzm": 198,
	"./tzm-latn": 199,
	"./tzm-latn.js": 199,
	"./tzm.js": 198,
	"./ug-cn": 200,
	"./ug-cn.js": 200,
	"./uk": 201,
	"./uk.js": 201,
	"./ur": 202,
	"./ur.js": 202,
	"./uz": 203,
	"./uz-latn": 204,
	"./uz-latn.js": 204,
	"./uz.js": 203,
	"./vi": 205,
	"./vi.js": 205,
	"./x-pseudo": 206,
	"./x-pseudo.js": 206,
	"./yo": 207,
	"./yo.js": 207,
	"./zh-cn": 208,
	"./zh-cn.js": 208,
	"./zh-hk": 209,
	"./zh-hk.js": 209,
	"./zh-mo": 210,
	"./zh-mo.js": 210,
	"./zh-tw": 211,
	"./zh-tw.js": 211
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 317;

/***/ }),

/***/ 318:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (value) {
  return value.toUpperCase();
});

/***/ }),

/***/ 319:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _this = this;

/* harmony default export */ __webpack_exports__["a"] = (function (value) {
  var first = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  if (first) {
    return _this[0].toUpperCase() + _this.substring(1);
  }

  var builder = '';

  for (var i = 0, length = _this.length; i < length; i++) {
    var c = _this[i - 1];
    if (!c || c === ' ' || c === '\t' || c === '\n') {
      c = _this[i].toUpperCase();
    } else {
      c = _this[i];
    }
    builder += c;
  }

  return builder;
});

/***/ }),

/***/ 325:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 326:
/***/ (function(module, exports) {

module.exports = {"about":"O projektu","add_guest":"Přidat hosta","add_guest_licence_agree":"Před přidáním hosta musíte přijmout podmínky používání KdoPřijel.cz a mít svolení od hosta použít jeho osobní údaje!","add_user_licence_agree":"Musíte přijmout včeobecné obchodní podmínky používání KdoPřijel.cz!","add_guest_fill_last_name":"Vyplňte alespoň příjmení hosta!","add_guest_add_tag":"Zvolte alespoň jeden důvod nahlášení hosta!","add_guest_required_data":"Vyplňte příjmení, město, stát a alespoň jeden z následujích údajů: číslo dokladu, e-mail, číslo víza!","add_guest_save_error":"Chyba při ukládání","api_key":"API klíč pro better-hotel.com","app_link":"http://www.kdoprijel.cz","app_title":"KdoPřijel.cz","avatar_choose_valid_image":"Zvolte soubor s obrázkem","cancel":"Zrušit","close":"Zavřít","contact_data":"Kontaktní údaje","city":"Město","compliance":"Shoda","country":"Národnost","czech":"Čeština","date":"Datum","delete":"Smazat","delete_guest":"Opravdu chcete smazat tohota hosta?","document_id":"Číslo dokladu","do_signup":"Zaregistrovat se do systému KdoPřijel.cz","edit_guest":"Editace hosta","english":"Angličtina","enter_at_least_3_characters":"Zadejte minimálně 3 znaky!","enter_at_least_5_characters":"Zadejte minimálně 5 znaků!","email":"E-mail","error":"Chyba","first_name":"Křestní jméno","field_country_mandatory":"Vyplňte národnost.","forget_password":"Zapomněli jste heslo?","guest_detail":"Detail hosta","guest_delete_tooltip":"Smazat hosta","guest_edit":"Editace hosta","guest_information":"Informace o hostovi","hotel_name":"Název hotelu","hotel_person":"Kontaktní osoba","hotel_url":"Webové stránky hotelu","choose_report_reasons":"Vyberte z uvedených štítků hlavní důvod(y), proč přidáváte hosta.","id":"#ID","last_name":"Přijmení","licence_agree":"Přijímám podmínky používání aplikace KdoPřijel.cz, mám svolení od hosta použít jeho osobní údaje a mám oprávnění poskytmout osobní údaje třetí straně.","licence_agree_1":"Přijímám podmínky používání aplikace KdoPřijel.cz,","licence_agree_2":"mám svolení od hosta použít jeho osobní údaje","licence_agree_3":"a mám oprávnění poskytmout osobní údaje třetí straně.","localization":"Lokalizace","logout":"Odhlásit","matches_found":"Nalezené shody","name":"Jméno","no":"Ne","no_records_entered":"Zatím jste nezadali žádné záznamy ...","no_records_found":"Nebyly nalezeny žádné záznamy ...","note":"Poznámka","password":"Heslo","password_change":"Změnit heslo","password_change_done":"Heslo bylo změněno ...","password_change_done_text":"Poslali jsme Vám e-mail s novým heslem.<br/>Přihlašte se na <a href='/signin'>přihlašovací stránce</a>","password_change_error":"Při změně hesla došlo k chybě ...","password_confirm":"Potvrďte heslo","password_match":"Zadaná hesla nesouhlasí","phone":"Telefonní číslo","please_signin":"Prosím přihlašte se ...","profile":"Profil","report_guest":"Nahlásit hosta","report_reason":"Důvod nahlášení","report_reasons":"Důvody nahlášení","reported_by":"Nahlásil","required_field":"Toto políčko musí být vyplněno","required_email":"Vyplňte validní adresu e-mailu","registration_confirm_title":"Vaše registrace čeká na potvrzení.","registration_confirm_content":"Profil hotelu byl založen, ale čeká na schválení. O schválení budete informováni na Vámi zadaný e-mail.","search":"Hledat","search_blacklist":"Prohledat databáze komunity KdoPřijel.cz ...","search_tips":"Tip: hledat můžete podle čísla dokladu, víza, e-mailu, telefonu nebo příjmení.","search_your_guests":"Prohledat vaše záznamy ...","share":"Sdílet","share_dlg_text":"Zadejte e-mail, na který chcete zaslat odkaz na<br/><b>KdoPřijel.cz</b>","share_done":"Odkaz na aplikaci byl odeslán ...","share_error":"Při sdílení došlo k chybě ...","sharing_is_caring":"Sharing is caring","sharing_is_caring_text":"Lorem ipsum dolor sit amet consectetur, adipisicing elit. Dolorum et iure beatae modi. Libero temporibus modi rem alias ipsa cumque facere ex eos natus. Hic repellat fuga nobis dolores temporibus!","signin":"Přihlásit se","signup":"Zaregistrovat se","signup_form":"Nová registrace hotelu","tac":"Všeobecné obchodní podmínky KdoPrijel.cz","total":"Celkem","yes":"Ano","your_records":"Vaše záznamy","your_note":"Vaše poznámka","unique_information":"Údaje pro jednoznačnou identifikaci","update_guest":"Upravit hosta","user_licence_agree":"Souhlasím a přijímám včeobecné obchodní podmínky používání KdoPřijel.cz!","validity":"Validita","vote":"Hlasování","vote_question":"Opravdu chcete hlasovat?","visum_number":"Číslo víza","warning":"Upozornění","tag_nopay":"Odjezd bez placení","tag_thief":"Krádež vybavení","tag_noshow":"Neplatná KK","tag_aggresor":"Agresor","tag_debtor":"Dlužník","tag_drugs":"Drogy","tag_fraud":"Podvodník","tag_identity":"Falešná identita","tag_duplicity":"Duplicitní rezervace","tag_other":"Jiný důvod","country_AF":"Afghánistán","country_AX":"Ålandy","country_AL":"Albánie","country_DZ":"Alžírsko","country_AS":"Americká Samoa","country_VI":"Americké Panenské ostrovy","country_AD":"Andorra","country_AO":"Angola","country_AI":"Anguilla","country_AQ":"Antarktida","country_AG":"Antigua a Barbuda","country_AR":"Argentina","country_AM":"Arménie","country_AW":"Aruba","country_AU":"Austrálie","country_AZ":"Ázerbájdžán","country_BS":"Bahamy","country_BH":"Bahrajn","country_BD":"Bangladéš","country_BB":"Barbados","country_BE":"Belgie","country_BZ":"Belize","country_BY":"Bělorusko","country_BJ":"Benin","country_BM":"Bermudy","country_BT":"Bhútán","country_BO":"Bolívie","country_BA":"Bosna a Hercegovina","country_BW":"Botswana","country_BV":"Bouvetův ostrov","country_BR":"Brazílie","country_IO":"Britské indickooceánské území","country_VG":"Britské Panenské ostrovy","country_BN":"Brunej","country_BG":"Bulharsko","country_BF":"Burkina Faso","country_BI":"Burundi","country_CK":"Cookovy ostrovy","country_TD":"Čad","country_ME":"Černá Hora","country_CZ":"Česko","country_CN":"Čína","country_DK":"Dánsko","country_CD":"Demokratická republika Kongo","country_DM":"Dominika","country_DO":"Dominikánská republika","country_DJ":"Džibutsko","country_EG":"Egypt","country_EC":"Ekvádor","country_ER":"Eritrea","country_EE":"Estonsko","country_ET":"Etiopie","country_FO":"Faerské ostrovy","country_FK":"Falklandy (Malvíny)","country_FJ":"Fidži","country_PH":"Filipíny","country_FI":"Finsko","country_FR":"Francie","country_GF":"Francouzská Guyana","country_TF":"Francouzská jižní a antarktická území","country_PF":"Francouzská Polynésie","country_GA":"Gabon","country_GM":"Gambie","country_GH":"Ghana","country_GI":"Gibraltar","country_GD":"Grenada","country_GL":"Grónsko","country_GE":"Gruzie","country_GP":"Guadeloupe","country_GU":"Guam","country_GT":"Guatemala","country_GN":"Guinea","country_GW":"Guinea-Bissau","country_GG":"Guernsey","country_GY":"Guyana","country_HT":"Haiti","country_HM":"Heardův ostrov a McDonaldovy ostrovy","country_HN":"Honduras","country_HK":"Hongkong","country_CL":"Chile","country_HR":"Chorvatsko","country_IN":"Indie","country_ID":"Indonésie","country_IQ":"Irák","country_IR":"Írán","country_IE":"Irsko","country_IS":"Island","country_IT":"Itálie","country_IL":"Izrael","country_JM":"Jamajka","country_JP":"Japonsko","country_YE":"Jemen","country_JE":"Jersey","country_ZA":"Jihoafrická republika","country_GS":"Jižní Georgie a Jižní Sandwichovy ostrovy","country_KR":"Jižní Korea","country_JO":"Jordánsko","country_KY":"Kajmanské ostrovy","country_KH":"Kambodža","country_CM":"Kamerun","country_CA":"Kanada","country_CV":"Kapverdy","country_QA":"Katar","country_KZ":"Kazachstán","country_KE":"Keňa","country_KI":"Kiribati","country_CC":"Kokosové ostrovy","country_CO":"Kolumbie","country_KM":"Komory","country_CG":"Kongo","country_CR":"Kostarika","country_CU":"Kuba","country_KW":"Kuvajt","country_CY":"Kypr","country_KG":"Kyrgyzstán","country_LA":"Laos","country_LS":"Lesotho","country_LB":"Libanon","country_LR":"Libérie","country_LY":"Libye","country_LI":"Lichtenštejnsko","country_LT":"Litva","country_LV":"Lotyšsko","country_LU":"Lucembursko","country_MO":"Macao","country_MG":"Madagaskar","country_HU":"Maďarsko","country_MK":"Makedonie","country_MY":"Malajsie","country_MW":"Malawi","country_MV":"Maledivy","country_ML":"Mali","country_MT":"Malta","country_IM":"Ostrov Man","country_MA":"Maroko","country_MH":"Marshallovy ostrovy","country_MQ":"Martinik","country_MU":"Mauricius","country_MR":"Mauritánie","country_YT":"Mayotte","country_UM":"Menší odlehlé ostrovy USA","country_MX":"Mexiko","country_FM":"Mikronésie","country_MD":"Moldavsko","country_MC":"Monako","country_MN":"Mongolsko","country_MS":"Montserrat","country_MZ":"Mosambik","country_MM":"Myanmar","country_NA":"Namibie","country_NR":"Nauru","country_DE":"Německo","country_NP":"Nepál","country_NE":"Niger","country_NG":"Nigérie","country_NI":"Nikaragua","country_NU":"Niue","country_NL":"Nizozemsko","country_NF":"Norfolk","country_NO":"Norsko","country_NC":"Nová Kaledonie","country_NZ":"Nový Zéland","country_OM":"Omán","country_PK":"Pákistán","country_PW":"Palau","country_PS":"Palestinská autonomie","country_PA":"Panama","country_PG":"Papua-Nová Guinea","country_PY":"Paraguay","country_PE":"Peru","country_PN":"Pitcairnovy ostrovy","country_CI":"Pobřeží slonoviny","country_PL":"Polsko","country_PR":"Portoriko","country_PT":"Portugalsko","country_AT":"Rakousko","country_RE":"Réunion","country_GQ":"Rovníková Guinea","country_RO":"Rumunsko","country_RU":"Rusko","country_RW":"Rwanda","country_GR":"Řecko","country_PM":"Saint-Pierre a Miquelon","country_SV":"Salvador","country_WS":"Samoa","country_SM":"San Marino","country_SA":"Saúdská Arábie","country_SN":"Senegal","country_KP":"Severní Korea","country_MP":"Severní Mariany","country_SC":"Seychely","country_SL":"Sierra Leone","country_SG":"Singapur","country_SK":"Slovensko","country_SI":"Slovinsko","country_SO":"Somálsko","country_AE":"Spojené arabské emiráty","country_GB":"Spojené království","country_US":"Spojené státy americké","country_RS":"Srbsko","country_CF":"Středoafrická republika","country_SD":"Súdán","country_SR":"Surinam","country_SH":"Svatá Helena, Ascension a Tristan da Cunha","country_LC":"Svatá Lucie","country_BL":"Svatý Bartoloměj","country_KN":"Svatý Kryštof a Nevis","country_MF":"Svatý Martin (francouzská část)","country_SX":"Svatý Martin (nizozemská část)","country_ST":"Svatý Tomáš a Princův ostrov","country_VC":"Svatý Vincenc a Grenadiny","country_SZ":"Svazijsko","country_SY":"Sýrie","country_SB":"Šalamounovy ostrovy","country_ES":"Španělsko","country_SJ":"Špicberky a Jan Mayen","country_LK":"Šrí Lanka","country_SE":"Švédsko","country_CH":"Švýcarsko","country_TJ":"Tádžikistán","country_TZ":"Tanzanie","country_TH":"Thajsko","country_TW":"Tchaj-wan","country_TG":"Togo","country_TK":"Tokelau","country_TO":"Tonga","country_TT":"Trinidad a Tobago","country_TN":"Tunisko","country_TR":"Turecko","country_TM":"Turkmenistán","country_TC":"Turks a Caicos","country_TV":"Tuvalu","country_UG":"Uganda","country_UA":"Ukrajina","country_UY":"Uruguay","country_UZ":"Uzbekistán","country_CX":"Vánoční ostrov","country_VU":"Vanuatu","country_VA":"Vatikán","country_VE":"Venezuela","country_VN":"Vietnam","country_TL":"Východní Timor","country_WF":"Wallis a Futuna","country_ZM":"Zambie","country_EH":"Západní Sahara","country_ZW":"Zimbabwe"}

/***/ }),

/***/ 33:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(2);




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      sideNav: false,
      showDialog: false,

      defaultLangs: [{ name: 'czech', code: 'cs', iso: 'CZE' }, { name: 'english', code: 'en', iso: 'GBR' }],
      activeLanguage: ''
    };
  },
  created: function created() {
    this.activeLanguage = this.$ls.get('active_language', 'cs');
  },


  computed: {
    menuItems: function menuItems() {
      var menuItems = [{ icon: 'lock_open', title: this.$t('signin'), link: '/signin' }, { icon: 'face', title: this.$t('signup'), link: '/signup' }, { icon: 'info_outline', title: this.$t('about'), link: '' }];
      if (this.userIsAuthenticated) {
        menuItems = [{ icon: 'search', title: this.$t('search'), link: '/search' }, { icon: 'supervisor_account', title: this.$t('your_records'), link: '/profile-guests' }, { icon: 'person', title: this.$t('profile'), link: '/profile' }, { icon: 'info_outline', title: this.$t('about'), link: '/' }];
      }
      return menuItems;
    },
    userIsAuthenticated: function userIsAuthenticated() {
      var user = this.$store.getters.user;

      return user !== null && user !== undefined && user.uid && user.uid !== null;
    },
    hotel_name: function hotel_name() {
      var user = this.$store.getters.user;
      return user === null || user === undefined ? '' : user.hotel;
    },
    user: function user() {
      return this.$store.getters.user;
    }
  },

  watch: {
    activeLanguage: function activeLanguage(val) {
      this.$ls.set('active_language', val);

      this.$polyglot.getLocale({ baseURL: 'static/i18n', lang: val });
      this.$polyglot.setLang({ lang: val });
    }
  },

  methods: {
    doShare: function doShare() {
      var _this = this;

      this.$swal({
        title: this.$t('share'),
        html: this.$t('share_dlg_text'),
        type: 'question',
        input: 'email',
        showCancelButton: true,
        confirmButtonText: this.$t('share'),
        cancelButtonText: this.$t('cancel')
      }).then(function (result) {
        if (result.value) {
          __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* HTTP */].post('share', { email: result.value }).then(function (response) {
            if (response.data.status > 0) {
              _this.$swal({
                position: 'bottom-right',
                type: 'success',
                title: _this.$t('share_done'),
                showConfirmButton: false,
                timer: 3000
              });
            }
          }).catch(function (error) {
            console.log('ERROR Blacklist - sharing: ' + error);
            _this.$swal({
              position: 'bottom-right',
              type: 'error',
              title: _this.$t('share_error'),
              showConfirmButton: false,
              timer: 3000
            });
          });
        }
      });
    },
    about: function about() {
      window.open(this.$t('app_link'), '_blank');
    },
    onLogout: function onLogout() {
      this.$store.dispatch('logout');
      this.$router.push('/');
    },
    setActiveLanguage: function setActiveLanguage(code) {
      this.activeLanguage = code;
      this.sideNav = false;
    },
    getCountryFlagUrl: function getCountryFlagUrl(iso) {
      return __WEBPACK_IMPORTED_MODULE_0__utils__["b" /* getCountryFlagUrl */](iso);
    }
  }
});

/***/ }),

/***/ 56:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth_guard__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_User_About__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_User_Profile__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_User_ProfileGuests__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_User_Signin__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_User_Signup__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_User_SignupConfirm__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_User_ForgetPassword__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Guests_Search__ = __webpack_require__(306);













__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'SignIn',
    component: __WEBPACK_IMPORTED_MODULE_6__components_User_Signin__["a" /* default */]
  }, {
    path: '/about',
    name: 'About',
    component: __WEBPACK_IMPORTED_MODULE_3__components_User_About__["a" /* default */]
  }, {
    path: '/profile',
    name: 'Profile',
    component: __WEBPACK_IMPORTED_MODULE_4__components_User_Profile__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_2__auth_guard__["a" /* default */]
  }, {
    path: '/profile-guests',
    name: 'ProfileGuests',
    component: __WEBPACK_IMPORTED_MODULE_5__components_User_ProfileGuests__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_2__auth_guard__["a" /* default */]
  }, {
    path: '/signin',
    name: 'Signin',
    component: __WEBPACK_IMPORTED_MODULE_6__components_User_Signin__["a" /* default */]
  }, {
    path: '/signup',
    name: 'Signup',
    component: __WEBPACK_IMPORTED_MODULE_7__components_User_Signup__["a" /* default */]
  }, {
    path: '/signup-confirm',
    name: 'SignupConfirm',
    component: __WEBPACK_IMPORTED_MODULE_8__components_User_SignupConfirm__["a" /* default */]
  }, {
    path: '/forget-password',
    name: 'ForgetPassword',
    component: __WEBPACK_IMPORTED_MODULE_9__components_User_ForgetPassword__["a" /* default */]
  }, {
    path: '/search',
    name: 'Search',
    component: __WEBPACK_IMPORTED_MODULE_10__components_Guests_Search__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_2__auth_guard__["a" /* default */]
  }, {
    path: '*',
    name: 'SignIn',
    component: __WEBPACK_IMPORTED_MODULE_6__components_User_Signin__["a" /* default */]
  }],
  mode: 'history'
}));

/***/ }),

/***/ 57:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },


  methods: {}
});

/***/ }),

/***/ 58:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},

  data: function data() {
    return {
      loading: true,
      profile: {},

      password: '',
      confirmPassword: ''
    };
  },
  created: function created() {
    var self = this;
    self.loading = true;

    __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* HTTP */].get('profile').then(function (response) {
      self.profile = response.data;
      self.loading = false;
    });
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    user: 'user'
  }), {
    comparePasswords: function comparePasswords() {
      return this.password !== this.confirmPassword ? this.$t('password_match') : '';
    },
    validPassword: function validPassword() {
      return this.password && this.password.length >= 5 && this.password === this.confirmPassword;
    }
  }),

  methods: {
    countryFlag: function countryFlag() {
      if (!this.profile.hotel_country) {
        return '';
      }
      return __WEBPACK_IMPORTED_MODULE_2__utils__["b" /* getCountryFlagUrl */](this.profile.hotel_country);
    },
    countryName: function countryName() {
      if (!this.profile.hotel_country) {
        return '';
      }
      return __WEBPACK_IMPORTED_MODULE_2__utils__["c" /* getCountryName */](this, this.profile.hotel_country);
    },
    getHrefUrl: function getHrefUrl() {
      return __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* getHrefUrl */](this.profile.hotel_url);
    },
    changePassword: function changePassword() {
      var _this = this;

      if (!this.password || this.password.length < 5) {
        this.$notify({
          group: 'app',
          type: 'error',
          text: '<center>' + this.$t('enter_at_least_5_characters') + '</center>',
          duration: 2000
        });
        return;
      }
      this.loading = true;

      __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* HTTP */].post('profile/change-password', { password: this.password }).then(function (response) {
        if (response.data.status > 0) {
          _this.password = '';
          _this.confirmPassword = '';
          _this.$swal({
            position: 'bottom-right',
            type: 'success',
            title: _this.$t('password_change_done'),
            showConfirmButton: false,
            timer: 3000
          });
        }
        _this.loading = false;
      }).catch(function (error) {
        _this.loading = false;
        console.log('ERROR Blacklist - profile: ' + error);
        _this.$swal({
          position: 'bottom-right',
          type: 'error',
          title: _this.$t('password_change_error'),
          showConfirmButton: false,
          timer: 3000
        });
      });
    }
  }
});

/***/ }),

/***/ 61:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Guests_GuestsList__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    GuestsList: __WEBPACK_IMPORTED_MODULE_0__Guests_GuestsList__["a" /* default */]
  },

  data: function data() {
    return {
      loading: false,
      filtering: false,
      filter: '',
      guests: [],
      filter_guests: []
    };
  },
  created: function created() {
    var self = this;
    self.loading = true;

    __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* HTTP */].get('profile/guests').then(function (response) {
      self.guests = response.data;
      self.filter_guests = self.guests;
      self.loading = false;
    });
  },
  mounted: function mounted() {
    var _this = this;

    requestAnimationFrame(function () {
      _this.$refs.focus.focus();
    });
  },


  methods: {
    onFilter: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
      this.doFilter(this.filter);
    }, 300),

    clearFilter: function clearFilter() {
      this.filter = '';
      this.doFilter('');
    },
    doFilter: function doFilter(value) {
      if (value === '') {
        this.filter_guests = this.guests;
        return;
      }
      this.filtering = true;
      this.filter_guests = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(this.guests, function (g) {
        return g.last_name.indexOf(value) !== -1 || g.document_id && g.document_id.indexOf(value) !== -1 || g.visum && g.visum.indexOf(value) !== -1 || g.phone && g.phone.indexOf(value) !== -1 || g.email && g.email.indexOf(value) !== -1 || g.company && g.company.indexOf(value) !== -1;
      });
      this.filtering = false;
    }
  }
});

/***/ }),

/***/ 62:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GuestsList_vue__ = __webpack_require__(63);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ac20f530_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GuestsList_vue__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(287)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ac20f530"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GuestsList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ac20f530_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GuestsList_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ac20f530_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GuestsList_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 63:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GuestDetail__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_TagReasonsList__ = __webpack_require__(65);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'guests-list',
  props: {
    guests: {
      required: true
    },
    editable: {
      type: Boolean,
      default: false
    }
  },
  components: {
    GuestDetail: __WEBPACK_IMPORTED_MODULE_2__GuestDetail__["a" /* default */], TagReasonsList: __WEBPACK_IMPORTED_MODULE_3__components_TagReasonsList__["a" /* default */]
  },

  data: function data() {
    return {
      showDialog: false,
      showGuestDetailDialog: false,
      editedGuest: null,
      otherMouseClick: false
    };
  },

  computed: {
    user: function user() {
      return this.$store.getters.user;
    }
  },

  methods: {
    editGuest: function editGuest(index) {
      this.editedIndex = index;
      this.editedGuest = this.guests[index];
      this.showDialog = true;
    },
    closeDialog: function closeDialog(guest) {
      if (guest === 'deleted') {
        this.guest.splice(this.editedIndex, 1);
      } else if (guest !== null) {
        this.guests[this.editedIndex] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.guests[this.editedIndex], guest);
      }
      this.showDialog = false;
    },
    showDetailDialog: function showDetailDialog(index) {
      var _this = this;

      setTimeout(function () {
        if (_this.otherMouseClick) {
          _this.otherMouseClick = false;
          return;
        }
        _this.editedGuest = _this.guests[index];
        _this.showGuestDetailDialog = true;
      }, 100);
    },
    closeDetailDialog: function closeDetailDialog() {
      this.showGuestDetailDialog = false;
    },
    confirmVote: function confirmVote(guest, action) {
      var _this2 = this;

      this.otherMouseClick = true;

      this.$swal({
        title: this.$t('vote'),
        text: this.$t('vote_question'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('yes'),
        cancelButtonText: this.$t('no')
      }).then(function (result) {
        if (result.value) {
          _this2.doVote(guest, action);
        }
      });
    },
    doVote: function doVote(guest, action) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* HTTP */].post('guest/' + guest.id + '/vote', { action: action }).then(function (result) {
        if (result.data.status < 0) {
          _this3.$swal(_this3.$t('error'), result.data.message, 'error');
        } else {
          guest.positive = result.data.positive;
          guest.negative = result.data.negative;
        }
      }).catch(function (error) {
        console.log('Error: ' + error.message);
        _this3.$notify({
          group: 'app',
          type: 'error',
          text: '<center>' + error.message + '</center>',
          duration: 1000
        });
      });
    },
    getHotelUrl: function getHotelUrl(guest) {
      return __WEBPACK_IMPORTED_MODULE_1__utils__["d" /* getHrefUrl */](guest.hotel_url);
    },
    getCountryFlagUrl: function getCountryFlagUrl(iso) {
      return __WEBPACK_IMPORTED_MODULE_1__utils__["b" /* getCountryFlagUrl */](iso);
    }
  }
});

/***/ }),

/***/ 64:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_TagReasonsList__ = __webpack_require__(65);





/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    guest: {
      required: true
    }
  },

  components: {
    TagReasonsList: __WEBPACK_IMPORTED_MODULE_1__components_TagReasonsList__["a" /* default */]
  },

  data: function data() {
    return {};
  },


  computed: {
    guestName: function guestName() {
      if (this.guest === null || this.guest === undefined) {
        return '';
      }
      var s = this.guest.first_name;
      if (this.guest.middle_name) {
        s += s.length > 0 ? ' ' : '';
        s += this.guest.midle_name;
      }
      if (this.guest.last_name) {
        s += s.length > 0 ? ' ' : '';
        s += this.guest.last_name;
      }
      return s;
    },
    guestCountryName: function guestCountryName() {
      if (!this.guest) {
        return '';
      }
      return __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* getCountryName */](this, this.guest.country);
    },
    guestNote: function guestNote() {
      if (!this.guest) {
        return '';
      }
      return this.guest.note;
    },
    guestTags: function guestTags() {
      return !this.guest ? [] : this.guest.tags;
    }
  },

  methods: {
    closeDialog: function closeDialog(guest) {
      this.$emit('closeDialog', guest);
    },
    getCountryFlagUrl: function getCountryFlagUrl(code) {
      if (!this.guest) {
        return '';
      }
      return __WEBPACK_IMPORTED_MODULE_0__utils__["b" /* getCountryFlagUrl */](code);
    },
    getHotelUrl: function getHotelUrl(guest) {
      if (!guest) {
        return '';
      }
      return __WEBPACK_IMPORTED_MODULE_0__utils__["d" /* getHrefUrl */](guest.hotel_url);
    }
  }
});

/***/ }),

/***/ 65:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TagReasonsList_vue__ = __webpack_require__(66);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5034e9d6_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TagReasonsList_vue__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TagReasonsList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5034e9d6_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TagReasonsList_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5034e9d6_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TagReasonsList_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 66:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(2);




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    tags: {
      default: [],
      required: true
    }
  },

  data: function data() {
    return {
      data: [],
      default_tags: []
    };
  },


  computed: {
    reasonTags: function reasonTags() {
      return !this.tags ? [] : this.tags;
    }
  },

  methods: {
    getTagName: function getTagName(code) {
      return __WEBPACK_IMPORTED_MODULE_0__utils__["g" /* getTagName */](this, code);
    },
    getTagIconText: function getTagIconText(code) {
      return __WEBPACK_IMPORTED_MODULE_0__utils__["e" /* getTagIconText */](code);
    },
    getTagIconUrl: function getTagIconUrl(code) {
      return __WEBPACK_IMPORTED_MODULE_0__utils__["f" /* getTagIconUrl */](code);
    }
  }
});

/***/ }),

/***/ 68:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(2);




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      email: '',
      password: '',
      loading: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    requestAnimationFrame(function () {
      _this.$refs.focus.focus();
    });
  },


  methods: {
    onSignin: function onSignin() {
      var _this2 = this;

      var self = this;
      var data = {
        email: this.email,
        password: this.password
      };
      this.loading = true;
      __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* HTTP */].post('signin', data).then(function (response) {
        _this2.loading = false;
        var data = response.data;
        if (data.status < 0) {
          console.log('Signin error: ' + data.message);
          Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* showError */])(self, data.message);
        } else {
          _this2.$store.commit('setUser', data.user);
          _this2.$router.push('/search');
        }
      }).catch(function (error) {
        console.log('SignIn error: ' + error.message);
        _this2.loading = false;
        Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* showError */])(self, error.message);
      });
    }
  }
});

/***/ }),

/***/ 69:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_CountrySelect__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_TacDialog__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    CountrySelect: __WEBPACK_IMPORTED_MODULE_0__components_CountrySelect__["a" /* default */],
    'tac-dialog': __WEBPACK_IMPORTED_MODULE_1__components_TacDialog__["a" /* default */]
  },

  data: function data() {
    return {
      hotel: '',
      hotel_person: '',
      hotel_url: '',
      hotel_city: '',
      hotel_country: '',
      email: '',
      password: '',
      confirmPassword: '',

      loading: false,
      licence_agree: false,
      showTacDialog: false
    };
  },


  computed: {
    comparePasswords: function comparePasswords() {
      return this.password !== this.confirmPassword ? this.$t('password_match') : '';
    }
  },

  methods: {
    onSignup: function onSignup() {
      var _this = this;

      var self = this;

      if (!this.licence_agree) {
        Object(__WEBPACK_IMPORTED_MODULE_2__utils__["h" /* showError */])(self, this.$t('add_user_licence_agree'));
        return;
      }

      if (this.hotel_country === '') {
        this.$swal({
          title: this.$t('warning'),
          text: this.$t('field_country_mandatory'),
          type: 'warning'
        });
        return;
      }

      var user = {
        email: this.email,
        password: this.password,
        hotel: this.hotel,
        hotel_person: this.hotel_person,
        hotel_url: this.hotel_url,
        hotel_city: this.hotel_city,
        hotel_country: this.hotel_country
      };

      this.loading = true;

      __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* HTTP */].post('signup', user).then(function (response) {
        _this.loading = false;
        var data = response.data;
        if (data.status < 0) {
          console.log('Signup error: ' + data.message);
          Object(__WEBPACK_IMPORTED_MODULE_2__utils__["h" /* showError */])(self, data.message);
        } else {
          _this.$router.push('/signup-confirm');
        }
      }).catch(function (error) {
        console.log('SignUp error: ' + error.message);
        _this.loading = false;
        Object(__WEBPACK_IMPORTED_MODULE_2__utils__["h" /* showError */])(self, error.message);
      });
    }
  }
});

/***/ }),

/***/ 70:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CountrySelect_vue__ = __webpack_require__(71);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42967972_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CountrySelect_vue__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CountrySelect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42967972_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CountrySelect_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42967972_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CountrySelect_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 71:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_lookups__ = __webpack_require__(21);





/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    country: {
      default: '',
      required: true
    },
    required: {
      type: Boolean,
      default: false
    },
    hideDetails: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      data: '',
      countries: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__utils_lookups__["a" /* COUNTRIES */].forEach(function (value, key, map) {
      _this.countries.push({ code: key, name: value.name, alpha2: value.alpha2, flag: __WEBPACK_IMPORTED_MODULE_0__utils__["b" /* getCountryFlagUrl */](key) });
    });
  },


  watch: {
    country: function country(value) {
      this.data = value;
    },
    data: function data(value) {
      this.$emit('update:country', value);
    }
  },

  methods: {
    countryFilter: function countryFilter(item, queryText, itemText) {
      if (!itemText || !queryText || queryText === '' || item === null || item === undefined || item.name === '') {
        return true;
      }
      var name = this.$t('country_' + item.alpha2);
      return name.toLowerCase().indexOf(queryText.toLowerCase()) > -1;
    }
  }
});

/***/ }),

/***/ 72:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TacDialog_vue__ = __webpack_require__(73);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10824c92_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TacDialog_vue__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TacDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10824c92_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TacDialog_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10824c92_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TacDialog_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 73:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    showDialog: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      tac: 'Všeobecné obchodní podmínky pro využívání internetové aplikace společnosti Mevris Group s.r.o. se sídlem Rybná 716/24, Staré Město, 110 00 Praha 1, IČO: 02465345, zapsané v obchodním rejstříku vedeném Městským soudem v Praze, oddíl C, vložka 219677\n' + 'Vzájemná práva a povinnosti Uživatele a Provozovatele vystávající z užívání Aplikace se řídí těmito podmínkami:\n' + 'I. Definice\n' + '1.1 V těchto všeobecných obchodních podmínkách se rozumí:\n' + '1.1.1 „Provozovatel” je společnost  Mevris Group s.r.o. se sídlem Rybná 716/24, Staré Město, 110 00 Praha 1, IČO: 02465345, zapsané v obchodním rejstříku vedeném Městským soudem v Praze, oddíl C, vložka 219677.\n' + '1.1.2 „Software” je internetová aplikace s názvem KdoPrijel.cz, která je dostupná z internetové adresy www.better-hotel.com\n' + '1.1.3 „VOP” jsou tyto Všeobecné obchodní podmínky.\n' + '1.1.4 „Smlouva“ znamená smlouvu uzavřenou mezi Uživatelem a Provozovatelem, jejímž předmětem je poskytnutí Licence k užívání Aplikace Uživateli za podmínek uvedených v těchto VOP.\n' + '1.1.5 „Licence“ znamená nevýhradní licenci k užívání Aplikace za podmínek uvedených v těchto VOP.\n' + '1.1.6 „Uživatelský účet“ znamená neveřejnou část Aplikace, která je uživateli přístupná po zadání Přihlašovacích údajů.\n' + '1.1.7 „Přihlašovací údaje“ znamenají unikátní kombinaci přihlašovacího jména Uživatele a hesla zvoleného Uživatelem, které Uživatel uloží do databáze Aplikace při zřizování Uživatelského účtu prostřednictvím Aplikace a/nebo Uživateli automaticky vygenerovaného Aplikací.\n' + 'II. Proces uzavření smlouvy o užívání Software\n' + '2.1 Zobrazení tlačítka s názvem: „Aktivovat” v uživatelském prostředí Software je návrhem na uzavření Smlouvy ze strany Provozovatele.\n' + '2.2 Kliknutí Uživatele na tlačítko „Aktivovat” “ je bezvýhradným přijetím návrhu na uzavření Smlouvy ze strany Uživatele a tímto úkonem je uzavřena Smlouva.\n' + '2.3 Kliknutím na pole (tzv. checkbox), které obsahuje popis ve znění „Souhlasím se podmínkami používání aplikace KdoPrijel.cz. “ a následným kliknutím na tlačítko ve smyslu 2.2. Uživatel vyjadřuje souhlas s těmito VOP.\n' + '2.4 Uzavřením Smlouvy vstupují v účinnost následující ustanovení těchto VOP.\n' + 'III. Užívání software\n' + '3.1 Provozovatel uděluje Uživateli Licenci v rozsahu a za podmínek uvedených v uživatelském prostředí Aplikace, zejména uvedených u daného typu Uživatelského účtu.\n' + '3.2 Provozovatel uděluje Uživateli Licenci k užívání bezúplatně.\n' + '3.3 Provozovatel je po uplynutí doby Licence oprávněn plně anebo částečně znepřístupnit Uživatelský účet Uživatele.\n' + '3.4 Uživatel nesmí zřídit více než jeden Uživatelský účet.\n' + '3.5 Uživatel nemá právo udělit třetí osobě podlicenci k užívání Aplikace.\n' + '3.6 Provozovatel má právo Aplikaci nebo její část kdykoliv zcela odstavit, změnit a/nebo ji znepřístupnit z příslušné internetové adresy, a to z jakéhokoliv důvodu.\n' + '3.7 Uživatel má právo na užívání Aplikace za podmínek Smlouvy v aktuální verzi dostupné z příslušné internetové adresy.\n' + '3.8 Uživatel se zavazuje při užívání Aplikace jednat tak, aby jemu ani Provozovateli užíváním Aplikace nevznikla žádná škoda.\n' + 'IV. Databáze\n' + '4.1 Uživatel nemá právo prostřednictvím Aplikace strojově (zejm. pomocí tzv. softwarových robotů) vytěžovat databázi spojenou s Aplikací\n' + '4.2 Uživatel a Provozovatel tímto sjednávají, že jakékoliv údaje vložené Uživatelem do databáze Aplikace jsou části databáze shromážděné Provozovatelem a stávají se součástí databáze Provozovatele, aniž by Uživateli jeho jednáním popsaným v tomto odstavci vzniklo jakékoliv právo k databázi Aplikace, či jakékoliv jiné databázi Provozovatele.\n' + '4.3 Smluvní strany jsou si vědomy, shodně prohlašují a činí nesporným, že Aplikace splňuje podmínky ust. § 562 odst. 2 občanského zákoníku, tedy že záznamy údajů v Aplikaci a její databázi jakožto elektronickém systému jsou spolehlivé a jsou prováděny systematicky a posloupně a jsou chráněny proti změnám.\n' + 'V. Osobní údaje a cookies\n' + '5.1 Souhlas Uživatele s užíváním souborů Cookies Provozovatelem uvedený v příloze č. 1 těchto VOP je součástí Smlouvy.\n' + '5.2 Souhlas Uživatele s poskytnutím osobních údajů Provozovateli uvedený v příloze č. 2 těchto VOP je součástí Smlouvy.\n' + '5.3 Uživatel výslovně potvrzuje, že k veškerým osobním údajům, které vkládá do Aplikace má řádný souhlas příslušných subjektů o poskytnutí osobních údajů a řádný souhlas s jejich sdílením třetím stranám.\n' + 'VI. Odpovědnost za škodu\n' + '6.1 Ustanovení toho článku VOP se nevztahují na spotřebitele.\n' + '6.2 Uživatel se tímto výslovně vzdává práva na náhradu škody od Provozovatele neúmyslně nebo nikoli z hrubé nedbalosti způsobené Provozovatelem porušením jakékoliv jeho povinností uvedených ve Smlouvě a porušených v souvislosti s plněním Smlouvy nebo v těchto VOP.\n' + 'VII. Změna VOP\n' + '7.2 Uživatel bere na vědomí, že Provozovatel uzavírá Smlouvu v běžném obchodním styku s větším počtem osob a Smlouvy jsou podle svého charakteru zavazující dlouhodobě k opětovným plněním stejného druhu s odkazem na tyto VOP. Smluvní strany činí nesporným, že z povahy závazků Provozovatele podle těchto VOP vyplývá a již před uzavřením Smlouvy vyplývala rozumná potřeba pozdější změny těchto VOP.\n' + '7.3 Smluvní strany tímto ujednávají, že Provozovatel může tyto VOP v přiměřeném rozsahu změnit, a zároveň ujednávají, že změna VOP bude Uživateli, jako druhé straně, oznámena prostřednictvím e-mailové zprávy odeslané na e-mailovou adresu zadanou Uživatelem do Aplikace. Uživatel má v takovém případě právo změny VOP odmítnout a předmětný závazek mezi ním a Provozovatelem z tohoto důvodu vypovědět ve výpovědní době jeden (1) kalendářní měsíc, která začne běžet den následující po odeslání oznámení, o které Smluvní strany tímto shodně prohlašují, že je dostatečná k obstarání obdobných plnění od jiného subjektu\n' + '7.4 V případě, že dojde k uzavření nové Smlouvy k již existujícímu Uživatelskému účtu (tj. k obnovení nebo prodloužení Uživatelského účtu), řídí se taková Smlouva VOP ve znění ke dni uzavření takové Smlouvy\n' + 'VIII. Povinné informace pro spotřebitele\n' + '8.1 Tento článek VOP podmínek je účinný pouze vůči Uživateli, který je spotřebitelem. Ustanovení uvedená v tomto článku VOP se nevztahují zejména na podnikatele – živnostníky nebo obchodní společnosti\n' + '8.2 Uživatel má právo od Smlouvy odstoupit bez uvedení důvodu a bez jakékoliv sankce do 14 dnů od převzetí plnění. Převzetím plnění se rozumí poskytnutí Licence;\n' + '8.3 Údaje o uzavření Smlouvy vč. těchto obchodních podmínek jsou uloženy v databázi Aplikace a Uživatel k nim má přístup prostřednictvím\n' + '8.4 Provozovatel dodržuje všechny platné zákony České republiky; žádné další kodexy nejsou pro Provozovatele závazné;\n' + '8.5 Provozovatel nevyužívá žádné prostředky mimosoudního řešení sporů;\n' + '8.6 Předmětem Smlouvy není dodání zboží, na Aplikace se tak nevztahují ustanovení zákona o reklamaci; odpovědnost za zjevné nebo skryté vady Aplikace, které měla Aplikace v době jejího zpřístupnění Uživateli, lze uplatnit u Provozovatele za podmínek stanovených zákonem, Smlouvou a těmito VOP;\n' + '8.7 Uživatel je povinen dodržovat tyto VOP, které jsou též součástí Smlouvy, a platné a účinné právní předpisy České republiky.\n' + 'IX. Rozhodné právo\n' + '9.1 Tyto VOP, jakož i Smlouva, se řídí právním řádem České republiky, zejména zák. č. 89/2012 Sb., občanský zákoník, ve znění pozdějších předpisů\n' + '9.2 Jakýkoliv spor vzniklý z těchto VOP nebo Smlouvy bude rozhodován před obecným soudem, který je místně příslušným soudem pro první instanci dle sídla Provozovatele.\n' + 'X. Účinnost\n' + '10.1 Tyto VOP nabývají účinnosti dne 1. 10. 2017\n' + '\n' + 'Příloha č. 1\n' + 'Souhlas se zpracováním souborů cookies\n' + '1.1 Co jsou soubory cookies\n' + 'Soubory cookies jsou krátké textové soubory, které internetová stránka odešle do Vašeho prohlížeče. Umožňují internetové stránce zaznamenat informace o Vaší návštěvě, například zvolený jazyk a podobně, následující návštěva stránek tak pro Vás může být snazší a příjemnější. Soubory cookies jsou důležité, neboť bez nich by procházení sítě Internet bylo mnohem složitější. Soubory cookies umožňují lepší využití naší internetové stránky a přizpůsobení jejího obsahu Vašim potřebám;  používá je téměř každá internetová stránka na světě. Soubory cookies jsou užitečné, protože zvyšují uživatelskou přívětivost opakovaně navštívené internetové stránky.\n' + '1.2 Druhy souborů cookies\n' + 'Relační (tedy dočasné) soubory cookies nám umožňují propojovat Vaše jednotlivé aktivity po dobu prohlížení těchto internetových stránek. V okamžiku otevření okna Vašeho prohlížeče se tyto soubory aktivují a deaktivují se po zavření okna Vašeho prohlížeče. Relační cookies jsou dočasné a po zavření prohlížeče se všechny tyto soubory vymažou.\n' + 'Trvalé soubory cookies nám pomáhají Váš počítač identifikovat, jestliže opětovně navštívíte naši internetovou stránku. Další výhodou trvalých cookies je to, že nám umožňují přizpůsobit naše internetové stránky Vašim potřebám.\n' + '1.3 Využívání souborů cookies\n' + 'V souladu s ustanovením § 89 odst. 3 zák. č. 127/2005 Sb., o elektronických komunikacích, v účinném znění, si Vás tímto dovolujeme informovat, že naše internetové stránky využívají pro svoji činnost soubory cookies, tedy že Vaše soubory cookies, včetně trvalých, zpracováváme.\n' + 'Tento souhlas je udělen na dobu 12 měsíců.\n' + 'Internetové prohlížeče obvykle obsahují správu souborů cookies. V rámci nastavení Vašeho prohlížeče tak pravděpodobně můžete jednotlivé soubory cookies ručně mazat, blokovat či zcela zakázat jejich používání. Pro více informací  použijte nápovědu svého internetového prohlížeče.\n' + '1.4 Účel použití souborů cookies\n' + 'K personalizaci obsahu a reklam, poskytování funkcí sociálních médií a analýze naší návštěvnosti využíváme soubory cookies. Informace o tom, jak náš web používáte, sdílíme se svými partnery působícími v oblasti sociálních médií, inzerce a analýz.\n' + 'Soubory cookies využíváme, kromě účelu uvedeného v předchozím odstavci, pouze pro účely stanovené v obchodních podmínkách.\n' + '\n' + 'Příloha č. 2\n' + 'Souhlas s užitím osobních údajů\n' + 'Já, jakožto uživatel internetové aplikace s názvem KdoPrijel.cz dostupné v síti Internet z internetové adresy www.better-hotel.com , tímto ve smyslu ust. § 5 odst. 2 zákona č. 101/2000 Sb., o ochraně osobních údajů, ve znění pozdějších předpisů (dále též jako „zákon“), souhlasím se shromažďováním, uchováním a zpracováním osobních údajů mnou poskytnutých správci osobních údajů, kterým je společnost Mevris Group s.r.o. se sídlem Rybná 716/24, Staré Město, 110 00 Praha 1, IČO: 02465345, zapsaná v obchodním rejstříku vedeném Městským soudem v Praze, oddíl C, vložka 219677 (dále též jako „správce“), a souhlasím s tím, aby mé osobní údaje byly zpracovány a použity správcem, jakýmkoliv zaměstnancem správce a jakýmkoliv smluvním partnerem správce.\n' + 'Tento souhlas je udělen na dobu neurčitou.\n' + 'Správcem stanovený účel zpracování osobních údajů, pro který tento souhlas poskytuji, je použití osobních údajů pro: zasílání obchodních nabídek správce, marketingové účely, poskytování osobních údajů třetím stranám, zařazení osobních údajů do databází, zpřístupnění osobních údajů třetím stranám.\n' + 'Prohlašuji, že jsem si vědom(a) svých práv podle ust. § 12 a § 21 zákona, a prohlašuji, že všechny údaje jsou přesné a pravdivé a jsou poskytovány dobrovolně\n' + 'Správce prohlašuje, že bude shromažďovat osobní údaje v rozsahu nezbytném pro naplnění výše stanoveného účelu a zpracovávat je pouze v souladu s účelem, k němuž byly shromážděny.\n' + 'Správce prohlašuje, že bude osobní údaje zpracovávat následujícím způsobem: strojově (automatizovaně) prostřednictvím počítačů a počítačových programů; v písemné podobě;\n' + 'Tento souhlas je svobodný a vědomý projev vůle subjektu údajů, jehož obsahem je svolení subjektu údajů se zpracováním osobních údajů.\n' + 'Souhlas je poskytnut kliknutím na tlačítko s nápisem: “Souhlasím a pokračovat” v uživatelském rozhraní výše popsané internetové aplikace.'
    };
  },


  computed: {
    htmlTac: function htmlTac() {
      return this.tac.replace(/\n/g, '<br/>');
    }
  },

  methods: {
    closeDialog: function closeDialog() {
      this.$emit('closeDialog');
    }
  }
});

/***/ }),

/***/ 74:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      email: '',
      loading: false
    };
  },


  methods: {
    createNewPassword: function createNewPassword() {
      var _this = this;

      var regex = new RegExp('^[a-zA-Z0-9-_.+]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$');
      if (!this.email || !regex.test(this.email)) {
        this.$swal({
          title: this.$t('warning'),
          text: this.$t('required_email'),
          type: 'warning'
        });
        return;
      }
      this.loading = true;
      __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* HTTP */].post('forget-password', { email: this.email }).then(function (response) {
        if (response.data.status > 0) {
          _this.$swal({
            position: 'bottom-right',
            type: 'success',
            title: _this.$t('password_change_done'),
            html: _this.$t('password_change_done_text'),
            confirmButtonText: _this.$t('close')
          });
        } else {
          throw new Error(response.data.message);
        }
        _this.loading = false;
      }).catch(function (error) {
        _this.loading = false;
        console.log('ERROR Blacklist - profile: ' + error);
        _this.$swal({
          position: 'bottom-right',
          type: 'error',
          title: _this.$t('password_change_error'),
          text: error.message,
          showConfirmButton: false,
          timer: 3000
        });
      });
    }
  }
});

/***/ }),

/***/ 75:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GuestsList__ = __webpack_require__(62);





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    GuestsList: __WEBPACK_IMPORTED_MODULE_1__GuestsList__["a" /* default */]
  },

  data: function data() {
    return {
      searchPerformed: false,
      loading: false,
      search: '',
      items: []
    };
  },
  created: function created() {},
  mounted: function mounted() {
    var _this = this;

    requestAnimationFrame(function () {
      _this.$refs.focus.focus();
    });
  },


  methods: {
    doSearch: function doSearch() {
      if (!this.search || this.search.length < 3) {
        this.$notify({
          group: 'app',
          type: 'error',
          text: '<center>' + this.$t('enter_at_least_3_characters') + '</center>',
          duration: 2000
        });
        return;
      }
      this.loading = true;
      this.searchPerformed = true;
      var self = this;
      var q = this.search;
      var params = { q: q };
      __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* HTTP */].get('guest', { params: params }).then(function (response) {
        self.items = response.data;
        self.loading = false;
      }).catch(function (error) {
        console.log(error);
        self.items = [];
        self.loading = false;
      });
    }
  }
});

/***/ }),

/***/ 76:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['text'],
  methods: {
    onClose: function onClose() {
      this.$emit('dismissed');
    }
  }
});

/***/ }),

/***/ 77:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_CountrySelect__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_TacDialog__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_TagReasonSelect__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(2);







/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    guest: {
      default: null
    }
  },
  components: {
    CountrySelect: __WEBPACK_IMPORTED_MODULE_0__components_CountrySelect__["a" /* default */],
    TagReasonSelect: __WEBPACK_IMPORTED_MODULE_2__components_TagReasonSelect__["a" /* default */],
    'tac-dialog': __WEBPACK_IMPORTED_MODULE_1__components_TacDialog__["a" /* default */]
  },

  data: function data() {
    return {
      first_name: '',
      middle_name: '',
      last_name: '',
      street: '',
      city: '',
      zip: '',
      country: '',
      company: '',
      company_possition: '',
      email: '',
      email_tag: '',
      phone: '',
      phone_tag: '',
      birthdate: null,
      document_id: '',
      visum_number: '',
      note: '',
      image_url: '',
      image: null,
      tags: [],

      licence_agree: false,
      showTacDialog: false
    };
  },


  computed: {
    edditing: function edditing() {
      return this.guest && this.guest.id;
    }
  },

  watch: {
    showDialog: function showDialog(value) {
      var _this = this;

      if (value && this.guest !== null) {
        this.first_name = this.guest.first_name;
        this.middle_name = this.guest.middle_name;
        this.last_name = this.guest.last_name;
        this.street = this.guest.street;
        this.city = this.guest.city;
        this.zip = this.guest.zip;
        this.country = this.guest.country;
        this.company = this.guest.company;
        this.company_possition = this.guest.company_possition;
        this.email = this.guest.email;
        this.email_tag = this.guest.email_tag;
        this.phone = this.guest.phone;
        this.phone_tag = this.guest.phone_tag;
        this.birthdate = this.guest.birthdate;
        this.document_id = this.guest.document_id;
        this.visum_number = this.guest.visum_number;
        this.note = this.guest.note;
        this.tags = this.guest.tags;
      } else {
        this.first_name = '';
        this.middle_name = '';
        this.last_name = '';
        this.street = '';
        this.city = '';
        this.zip = '';
        this.country = '';
        this.company = '';
        this.company_possition = '';
        this.email = '';
        this.email_tag = '';
        this.phone = '';
        this.phone_tag = '';
        this.birthdate = null;
        this.document_id = '';
        this.visum_number = '';
        this.note = '';
        this.tags = [];
      }
      if (value) {
        requestAnimationFrame(function () {
          _this.$refs.focus.focus();
        });
      }
    }
  },

  methods: {
    onSave: function onSave() {
      var _this2 = this;

      if (this.guest === null && !this.licence_agree) {
        this.$swal({
          title: this.$t('warning'),
          text: this.$t('add_guest_licence_agree'),
          type: 'warning'
        });
        return;
      }

      if (this.last_name.trim() === '' || this.country.trim() === '' || this.city.trim() === '' || this.document_id.trim() === '' && this.email.trim() === '' && this.visum_number.trim() === '') {
        this.$swal({
          title: this.$t('warning'),
          text: this.$t('add_guest_required_data'),
          type: 'warning'
        });
        return;
      }

      if (this.tags.length === 0) {
        this.$swal({
          title: this.$t('warning'),
          text: this.$t('add_guest_add_tag'),
          type: 'warning'
        });
        return;
      }

      var guest = {
        first_name: this.first_name,
        middle_name: this.middle_name,
        last_name: this.last_name,
        street: this.street,
        city: this.city,
        zip: this.zip,
        country: this.country,
        company: this.company,
        email: this.email,
        phone: this.phone,
        document_id: this.document_id,
        visum_number: this.visum_number,
        note: this.note,
        tags: this.tags
      };

      if (this.guest && this.guest.id) {
        __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* HTTP */].put('guest/' + this.guest.id, guest).then(function (result) {
          if (result.status < 0) {
            throw new Error(result.message);
          }
          guest.id = _this2.guest.id;
          _this2.closeDialog(guest);
        }).catch(function (error) {
          console.log('ERROR GuestDialog onSave: ' + error);
          _this2.$notify({
            group: 'app',
            type: 'error',
            text: '<center>' + _this2.$t('add_guest_save_error') + ': ' + error.message + '</center>',
            duration: 2000
          });
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* HTTP */].post('guest', guest).then(function (result) {
          if (result.status < 0) {
            throw new Error(result.message);
          }
          _this2.closeDialog(null);
        }).catch(function (error) {
          console.log('ERROR GuestDialog onSave: ' + error);
          __WEBPACK_IMPORTED_MODULE_3__utils__["h" /* showError */](_this2, _this2.$t('add_guest_save_error') + ': ' + error.message);
        });
      }
    },
    deleteGuest: function deleteGuest() {
      var _this3 = this;

      if (!this.guest || !this.guest.id) {
        return;
      }
      this.$swal({
        text: this.$t('delete_guest'),
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        confirmButtonText: this.$t('delete'),
        cancelButtonText: this.$t('no')
      }).then(function (result) {
        if (result.value) {
          __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* HTTP */].delete('guest/' + _this3.guest.id).then(function (result) {
            if (result.status < 0) {
              throw new Error(result.message);
            }
            _this3.closeDialog('deleted');
          }).catch(function (error) {
            console.log('ERROR GuestDialog onDelete: ' + error);
            __WEBPACK_IMPORTED_MODULE_3__utils__["h" /* showError */](_this3, error.message);
          });
        }
      });
    },
    closeDialog: function closeDialog(guest) {
      this.$emit('closeDialog', guest);
    }
  }
});

/***/ }),

/***/ 78:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_lookups__ = __webpack_require__(21);





/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    tags: {
      default: [],
      required: true
    },
    required: {
      default: false
    }
  },

  data: function data() {
    return {
      data: [],
      default_tags: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__utils_lookups__["b" /* TAGS */].forEach(function (value, key, map) {
      _this.default_tags.push({ code: key, icon_text: value.icon_text, icon: _this.getTagIconUrl(key) });
    });
  },


  watch: {
    tags: function tags(value) {
      this.data = value;
    },
    data: function data(value) {
      this.$emit('update:tags', value);
    }
  },

  methods: {
    getTagName: function getTagName(code) {
      return __WEBPACK_IMPORTED_MODULE_0__utils__["g" /* getTagName */](this, code);
    },
    getTagIconUrl: function getTagIconUrl(code) {
      return __WEBPACK_IMPORTED_MODULE_0__utils__["f" /* getTagIconUrl */](code);
    }
  }
});

/***/ })

},[212]);


// WEBPACK FOOTER //
// static/js/app.3708f284373b5e472ae1.js